/*
 * Font Awesome Icon Picker
 * https://farbelous.github.io/fontawesome-iconpicker/
 *
 * Originally written by (c) 2016 Javi Aguilar
 * Licensed under the MIT License
 * https://github.com/farbelous/fontawesome-iconpicker/blob/master/LICENSE
 *
 */

(function(factory) {
        "use strict";
        if (typeof define === 'function' && define.amd) {
            define(['jquery'], factory);
        } else if (window.jQuery && !window.jQuery.fn.iconpicker) {
            factory(window.jQuery);
        }
    }
    (function($) {
        'use strict';

        var _helpers = {
            isEmpty: function(val) {
                return ((val === false) || (val === '') || (val === null) || (val === undefined));
            },
            isEmptyObject: function(val) {
                return (this.isEmpty(val) === true) || (val.length === 0);
            },
            isElement: function(selector) {
                return ($(selector).length > 0);
            },
            isString: function(val) {
                return ((typeof val === 'string') || (val instanceof String));
            },
            isArray: function(val) {
                return $.isArray(val);
            },
            inArray: function(val, arr) {
                return ($.inArray(val, arr) !== -1);
            },
            throwError: function(text) {
                throw "Font Awesome Icon Picker Exception: " + text;
            }
        };

        var Iconpicker = function(element, options) {
            this._id = Iconpicker._idCounter++;
            this.element = $(element).addClass('iconpicker-element');
            this._trigger('iconpickerCreate', {
                iconpickerValue: this.iconpickerValue
            });
            this.options = $.extend({}, Iconpicker.defaultOptions, this.element.data(), options);
            this.options.templates = $.extend({}, Iconpicker.defaultOptions.templates, this.options.templates);
            this.options.originalPlacement = this.options.placement;
            // Iconpicker container element
            this.container = (_helpers.isElement(this.options.container) ? $(this.options.container) : false);
            if (this.container === false) {
                if (this.element.is('.dropdown-toggle')) {
                    this.container = $('~ .dropdown-menu:first', this.element);
                } else {
                    this.container = (this.element.is('input,textarea,button,.btn') ? this.element.parent() : this.element);
                }
            }
            this.container.addClass('iconpicker-container');

            if (this.isDropdownMenu()) {
                this.options.placement = 'inline';
            }

            // Is the element an input? Should we search inside for any input?
            this.input = (this.element.is('input,textarea') ? this.element.addClass('iconpicker-input') : false);
            if (this.input === false) {
                this.input = (this.container.find(this.options.input));
                if (!this.input.is('input,textarea')) {
                    this.input = false;
                }
            }

            // Plugin as component ?
            this.component = this.isDropdownMenu() ? this.container.parent().find(this.options.component) : this.container.find(this.options.component);
            if (this.component.length === 0) {
                this.component = false;
            } else {
                this.component.find('i').addClass('iconpicker-component');
            }

            // Create popover and iconpicker HTML
            this._createPopover();
            this._createIconpicker();

            if (this.getAcceptButton().length === 0) {
                // disable this because we don't have accept buttons
                this.options.mustAccept = false;
            }

            // Avoid CSS issues with input-group-addon(s)
            if (this.isInputGroup()) {
                this.container.parent().append(this.popover);
            } else {
                this.container.append(this.popover);
            }

            // Bind events
            this._bindElementEvents();
            this._bindWindowEvents();

            // Refresh everything
            this.update(this.options.selected);

            if (this.isInline()) {
                this.show();
            }

            this._trigger('iconpickerCreated', {
                iconpickerValue: this.iconpickerValue
            });
        };

        // Instance identifier counter
        Iconpicker._idCounter = 0;

        Iconpicker.defaultOptions = {
            title: false, // Popover title (optional) only if specified in the template
            selected: false, // use this value as the current item and ignore the original
            defaultValue: false, // use this value as the current item if input or element value is empty
            placement: 'bottom', // (has some issues with auto and CSS). auto, top, bottom, left, right
            collision: 'none', // If true, the popover will be repositioned to another position when collapses with the window borders
            animation: true, // fade in/out on show/hide ?
            //hide iconpicker automatically when a value is picked. it is ignored if mustAccept is not false and the accept button is visible
            hideOnSelect: false,
            showFooter: false,
            searchInFooter: false, // If true, the search will be added to the footer instead of the title
            mustAccept: false, // only applicable when there's an iconpicker-btn-accept button in the popover footer
            selectedCustomClass: 'bg-primary', // Appends this class when to the selected item
            icons: [], // list of icon classes (declared at the bottom of this script for maintainability)
            fullClassFormatter: function(val) {
                return val;
            },
            input: 'input,.iconpicker-input', // children input selector
            inputSearch: false, // use the input as a search box too?
            container: false, //  Appends the popover to a specific element. If not set, the selected element or element parent is used
            component: '.input-group-addon,.iconpicker-component', // children component jQuery selector or object, relative to the container element
            // Plugin templates:
            templates: {
                popover: '<div class="iconpicker-popover popover"><div class="arrow"></div>' +
                    '<div class="popover-title"></div><div class="popover-content"></div></div>',
                footer: '<div class="popover-footer"></div>',
                buttons: '<button class="iconpicker-btn iconpicker-btn-cancel btn btn-default btn-sm">Cancel</button>' +
                    ' <button class="iconpicker-btn iconpicker-btn-accept btn btn-primary btn-sm">Accept</button>',
                search: '<input type="search" class="form-control iconpicker-search" placeholder="Leita..." />',
                iconpicker: '<div class="iconpicker"><div class="iconpicker-items"></div></div>',
                iconpickerItem: '<a role="button" href="#" class="iconpicker-item"><i></i></a>',
            }
        };

        Iconpicker.batch = function(selector, method) {
            var args = Array.prototype.slice.call(arguments, 2);
            return $(selector).each(function() {
                var $inst = $(this).data('iconpicker');
                if (!!$inst) {
                    $inst[method].apply($inst, args);
                }
            });
        };

        Iconpicker.prototype = {
            constructor: Iconpicker,
            options: {},
            _id: 0, // instance identifier for bind/unbind events
            _trigger: function(name, opts) {
                //triggers an event bound to the element
                opts = opts || {};
                this.element.trigger($.extend({
                    type: name,
                    iconpickerInstance: this
                }, opts));
                //console.log(name + ' triggered for instance #' + this._id);
            },
            _createPopover: function() {
                this.popover = $(this.options.templates.popover);

                // title (header)
                var _title = this.popover.find('.popover-title');
                if (!!this.options.title) {
                    _title.append($('<div class="popover-title-text">' + this.options.title + '</div>'));
                }
                if (this.hasSeparatedSearchInput() && !this.options.searchInFooter) {
                    _title.append(this.options.templates.search);
                } else if (!this.options.title) {
                    _title.remove();
                }

                // footer
                if (this.options.showFooter && !_helpers.isEmpty(this.options.templates.footer)) {
                    var _footer = $(this.options.templates.footer);
                    if (this.hasSeparatedSearchInput() && this.options.searchInFooter) {
                        _footer.append($(this.options.templates.search));
                    }
                    if (!_helpers.isEmpty(this.options.templates.buttons)) {
                        _footer.append($(this.options.templates.buttons));
                    }
                    this.popover.append(_footer);
                }

                if (this.options.animation === true) {
                    this.popover.addClass('fade');
                }

                return this.popover;
            },
            _createIconpicker: function() {
                var _self = this;
                this.iconpicker = $(this.options.templates.iconpicker);

                var itemClickFn = function(e) {
                    var $this = $(this);
                    if ($this.is('i')) {
                        $this = $this.parent();
                    }

                    _self._trigger('iconpickerSelect', {
                        iconpickerItem: $this,
                        iconpickerValue: _self.iconpickerValue
                    });

                    if (_self.options.mustAccept === false) {
                        _self.update($this.data('iconpickerValue'));
                        _self._trigger('iconpickerSelected', {
                            iconpickerItem: this,
                            iconpickerValue: _self.iconpickerValue
                        });
                    } else {
                        _self.update($this.data('iconpickerValue'), true);
                    }

                    if (_self.options.hideOnSelect && (_self.options.mustAccept === false)) {
                        // only hide when the accept button is not present
                        _self.hide();
                    }
                };

                for (var i in this.options.icons) {
                    if (typeof this.options.icons[i].title === 'string') {
                        var itemElement = $(this.options.templates.iconpickerItem);
                        itemElement.find('i')
                            .addClass(this.options.fullClassFormatter(this.options.icons[i].title));
                        itemElement.data('iconpickerValue', this.options.icons[i].title)
                            .on('click.iconpicker', itemClickFn);
                        this.iconpicker.find('.iconpicker-items').append(itemElement
                            .attr('title', '.' + this.options.icons[i].title));

                        if (this.options.icons[i].searchTerms.length > 0) {
                            var searchTerms = '';
                            for (var j = 0; j < this.options.icons[i].searchTerms.length; j++) {
                                searchTerms = searchTerms + this.options.icons[i].searchTerms[j] + ' ';
                            }
                            this.iconpicker.find('.iconpicker-items').append(itemElement
                                .attr('data-search-terms', searchTerms));
                        }

                    }
                }

                this.popover.find('.popover-content').append(this.iconpicker);

                return this.iconpicker;
            },
            _isEventInsideIconpicker: function(e) {
                var _t = $(e.target);
                if ((!_t.hasClass('iconpicker-element') ||
                        (_t.hasClass('iconpicker-element') && !_t.is(this.element))) &&
                    (_t.parents('.iconpicker-popover').length === 0)) {
                    return false;
                }
                return true;
            },
            _bindElementEvents: function() {
                var _self = this;

                this.getSearchInput().on('keyup.iconpicker', function() {
                    _self.filter($(this).val().toLowerCase());
                });

                this.getAcceptButton().on('click.iconpicker', function() {
                    var _picked = _self.iconpicker.find('.iconpicker-selected').get(0);

                    _self.update(_self.iconpickerValue);

                    _self._trigger('iconpickerSelected', {
                        iconpickerItem: _picked,
                        iconpickerValue: _self.iconpickerValue
                    });
                    if (!_self.isInline()) {
                        _self.hide();
                    }
                });
                this.getCancelButton().on('click.iconpicker', function() {
                    if (!_self.isInline()) {
                        _self.hide();
                    }
                });

                this.element.on('focus.iconpicker', function(e) {
                    _self.show();
                    e.stopPropagation();
                });

                if (this.hasComponent()) {
                    this.component.on('click.iconpicker', function() {
                        _self.toggle();
                    });
                }

                if (this.hasInput()) {
                    // Bind input keyup event
                    this.input.on('keyup.iconpicker', function(e) {
                        if (!_helpers.inArray(e.keyCode, [38, 40, 37, 39, 16, 17, 18, 9, 8, 91, 93, 20, 46, 186, 190, 46, 78, 188, 44, 86])) {
                            _self.update();
                        } else {
                            _self._updateFormGroupStatus(_self.getValid(this.value) !== false);
                        }
                        if (_self.options.inputSearch === true) {
                            _self.filter($(this).val().toLowerCase());
                        }
                        //_self.hide();
                    });
                }

            },
            _bindWindowEvents: function() {
                var $doc = $(window.document);
                var _self = this;

                // Add a namespace to the document events so they can be identified
                // later for every instance separately
                var _eventNs = '.iconpicker.inst' + this._id;

                $(window).on('resize.iconpicker' + _eventNs + ' orientationchange.iconpicker' + _eventNs, function(e) {
                    // reposition popover
                    if (_self.popover.hasClass('in')) {
                        _self.updatePlacement();
                    }
                });

                if (!_self.isInline()) {
                    $doc.on('mouseup' + _eventNs, function(e) {
                        if (!_self._isEventInsideIconpicker(e) && !_self.isInline()) {
                            _self.hide();
                        }
                    });
                }
            },
            _unbindElementEvents: function() {
                this.popover.off('.iconpicker');
                this.element.off('.iconpicker');

                if (this.hasInput()) {
                    this.input.off('.iconpicker');
                }

                if (this.hasComponent()) {
                    this.component.off('.iconpicker');
                }

                if (this.hasContainer()) {
                    this.container.off('.iconpicker');
                }
            },
            _unbindWindowEvents: function() {
                // destroy window and window.document bound events
                $(window).off('.iconpicker.inst' + this._id);
                $(window.document).off('.iconpicker.inst' + this._id);
            },
            updatePlacement: function(placement, collision) {
                placement = placement || this.options.placement;
                this.options.placement = placement; // set new placement
                collision = collision || this.options.collision;
                collision = (collision === true ? 'flip' : collision);

                var _pos = {
                    // at: Defines which position (or side) on container element to align the
                    // popover element against: "horizontal vertical" alignment.
                    at: "right bottom",
                    // my: Defines which position (or side) on the popover being positioned to align
                    // with the container element: "horizontal vertical" alignment
                    my: "right top",
                    // of: Which element to position against.
                    of: (this.hasInput() && !this.isInputGroup()) ? this.input : this.container,
                    // collision: When the positioned element overflows the window (or within element)
                    // in some direction, move it to an alternative position.
                    collision: (collision === true ? 'flip' : collision),
                    // within: Element to position within, affecting collision detection.
                    within: window
                };

                // remove previous classes
                this.popover.removeClass('inline topLeftCorner topLeft top topRight topRightCorner ' +
                    'rightTop right rightBottom bottomRight bottomRightCorner ' +
                    'bottom bottomLeft bottomLeftCorner leftBottom left leftTop');

                if (typeof placement === 'object') {
                    // custom position ?
                    return this.popover.pos($.extend({}, _pos, placement));
                }

                switch (placement) {
                    case 'inline':
                        {
                            _pos = false;
                        }
                        break;
                    case 'topLeftCorner':
                        {
                            _pos.my = 'right bottom';
                            _pos.at = 'left top';
                        }
                        break;

                    case 'topLeft':
                        {
                            _pos.my = 'left bottom';
                            _pos.at = 'left top';
                        }
                        break;

                    case 'top':
                        {
                            _pos.my = 'center bottom';
                            _pos.at = 'center top';
                        }
                        break;

                    case 'topRight':
                        {
                            _pos.my = 'right bottom';
                            _pos.at = 'right top';
                        }
                        break;

                    case 'topRightCorner':
                        {
                            _pos.my = 'left bottom';
                            _pos.at = 'right top';
                        }
                        break;

                    case 'rightTop':
                        {
                            _pos.my = 'left bottom';
                            _pos.at = 'right center';
                        }
                        break;

                    case 'right':
                        {
                            _pos.my = 'left center';
                            _pos.at = 'right center';
                        }
                        break;

                    case 'rightBottom':
                        {
                            _pos.my = 'left top';
                            _pos.at = 'right center';
                        }
                        break;

                    case 'bottomRightCorner':
                        {
                            _pos.my = 'left top';
                            _pos.at = 'right bottom';
                        }
                        break;

                    case 'bottomRight':
                        {
                            _pos.my = 'right top';
                            _pos.at = 'right bottom';
                        }
                        break;
                    case 'bottom':
                        {
                            _pos.my = 'center top';
                            _pos.at = 'center bottom';
                        }
                        break;

                    case 'bottomLeft':
                        {
                            _pos.my = 'left top';
                            _pos.at = 'left bottom';
                        }
                        break;

                    case 'bottomLeftCorner':
                        {
                            _pos.my = 'right top';
                            _pos.at = 'left bottom';
                        }
                        break;

                    case 'leftBottom':
                        {
                            _pos.my = 'right top';
                            _pos.at = 'left center';
                        }
                        break;

                    case 'left':
                        {
                            _pos.my = 'right center';
                            _pos.at = 'left center';
                        }
                        break;

                    case 'leftTop':
                        {
                            _pos.my = 'right bottom';
                            _pos.at = 'left center';
                        }
                        break;

                    default:
                        {
                            return false;
                        }
                        break;

                }

                this.popover.css({
                    'display': (this.options.placement === 'inline') ? '' : 'block'
                });

                if (_pos !== false) {
                    this.popover.pos(_pos).css('maxWidth', $(window).width() - this.container.offset().left - 5);
                } else {
                    //reset position
                    this.popover.css({
                        'top': 'auto',
                        'right': 'auto',
                        'bottom': 'auto',
                        'left': 'auto',
                        'maxWidth': 'none'
                    });
                }
                this.popover.addClass(this.options.placement);

                return true;
            },
            _updateComponents: function() {
                // Update selected item
                this.iconpicker.find('.iconpicker-item.iconpicker-selected')
                    .removeClass('iconpicker-selected ' + this.options.selectedCustomClass);

                if (this.iconpickerValue) {
                    this.iconpicker.find('.' + this.options.fullClassFormatter(this.iconpickerValue).replace(/ /g, '.')).parent()
                        .addClass('iconpicker-selected ' + this.options.selectedCustomClass);
                }

                // Update component item
                if (this.hasComponent()) {
                    var icn = this.component.find('i');
                    if (icn.length > 0) {
                        icn.attr('class', this.options.fullClassFormatter(this.iconpickerValue));
                    } else {
                        this.component.html(this.getHtml());
                    }
                }

            },
            _updateFormGroupStatus: function(isValid) {
                if (this.hasInput()) {
                    if (isValid !== false) {
                        // Remove form-group error class if any
                        this.input.parents('.form-group:first').removeClass('has-error');
                    } else {
                        this.input.parents('.form-group:first').addClass('has-error');
                    }
                    return true;
                }
                return false;
            },
            getValid: function(val) {
                // here we must validate the value (you may change this validation
                // to suit your needs
                if (!_helpers.isString(val)) {
                    val = '';
                }

                var isEmpty = (val === '');

                // trim string
                val = $.trim(val);
                var e = false;
                for (var i = 0; i < this.options.icons.length; i++) {
                    if (this.options.icons[i].title === val) {
                        e = true;
                        break;
                    };
                }

                if (e || isEmpty) {
                    return val;
                }
                return false;
            },
            /**
             * Sets the internal item value and updates everything, excepting the input or element.
             * For doing so, call setSourceValue() or update() instead
             */
            setValue: function(val) {
                // sanitize first
                var _val = this.getValid(val);
                if (_val !== false) {
                    this.iconpickerValue = _val;
                    this._trigger('iconpickerSetValue', {
                        iconpickerValue: _val
                    });
                    return this.iconpickerValue;
                } else {
                    this._trigger('iconpickerInvalid', {
                        iconpickerValue: val
                    });
                    return false;
                }
            },
            getHtml: function() {
                return '<i class="' + this.options.fullClassFormatter(this.iconpickerValue) + '"></i>';
            },
            /**
             * Calls setValue and if it's a valid item value, sets the input or element value
             */
            setSourceValue: function(val) {
                val = this.setValue(val);
                if ((val !== false) && (val !== '')) {
                    if (this.hasInput()) {
                        this.input.val(this.iconpickerValue);
                    } else {
                        this.element.data('iconpickerValue', this.iconpickerValue);
                    }
                    this._trigger('iconpickerSetSourceValue', {
                        iconpickerValue: val
                    });
                }
                return val;
            },
            /**
             * Returns the input or element item value, without formatting, or defaultValue
             * if it's empty string, undefined, false or null
             * @param {type} defaultValue
             * @returns string|mixed
             */
            getSourceValue: function(defaultValue) {
                // returns the input or element value, as string
                defaultValue = defaultValue || this.options.defaultValue;
                var val = defaultValue;

                if (this.hasInput()) {
                    val = this.input.val();
                } else {
                    val = this.element.data('iconpickerValue');
                }
                if ((val === undefined) || (val === '') || (val === null) || (val === false)) {
                    // if not defined or empty, return default
                    val = defaultValue;
                }
                return val;
            },
            hasInput: function() {
                return (this.input !== false);
            },
            isInputSearch: function() {
                return (this.hasInput() && (this.options.inputSearch === true));
            },
            isInputGroup: function() {
                return this.container.is('.input-group');
            },
            isDropdownMenu: function() {
                return this.container.is('.dropdown-menu');
            },
            hasSeparatedSearchInput: function() {
                return (this.options.templates.search !== false) && (!this.isInputSearch());
            },
            hasComponent: function() {
                return (this.component !== false);
            },
            hasContainer: function() {
                return (this.container !== false);
            },
            getAcceptButton: function() {
                return this.popover.find('.iconpicker-btn-accept');
            },
            getCancelButton: function() {
                return this.popover.find('.iconpicker-btn-cancel');
            },
            getSearchInput: function() {
                return this.popover.find('.iconpicker-search');
            },
            filter: function(filterText) {
                if (_helpers.isEmpty(filterText)) {
                    this.iconpicker.find('.iconpicker-item').show();
                    return $(false);
                } else {
                    var found = [];
                    this.iconpicker.find('.iconpicker-item').each(function() {
                        var $this = $(this);
                        var text = $this.attr('title').toLowerCase();
                        var searchTerms = $this.attr('data-search-terms') ? $this.attr('data-search-terms').toLowerCase() : '';
                        text = text + ' ' + searchTerms;
                        var regex = false;
                        try {
                            regex = new RegExp('(^|\\W)' + filterText, 'g');
                        } catch (e) {
                            regex = false;
                        }
                        if ((regex !== false) && text.match(regex)) {
                            found.push($this);
                            $this.show();
                        } else {
                            $this.hide();
                        }
                    });
                    return found;
                }
            },
            show: function() {
                if (this.popover.hasClass('in')) {
                    return false;
                }
                // hide other non-inline pickers
                $.iconpicker.batch($('.iconpicker-popover.in:not(.inline)').not(this.popover), 'hide');

                this._trigger('iconpickerShow', {
                    iconpickerValue: this.iconpickerValue
                });
                this.updatePlacement();
                this.popover.addClass('in');
                setTimeout($.proxy(function() {
                    this.popover.css('display', this.isInline() ? '' : 'block');
                    this._trigger('iconpickerShown', {
                        iconpickerValue: this.iconpickerValue
                    });
                }, this), this.options.animation ? 300 : 1); // animation duration
            },
            hide: function() {
                if (!this.popover.hasClass('in')) {
                    return false;
                }
                this._trigger('iconpickerHide', {
                    iconpickerValue: this.iconpickerValue
                });
                this.popover.removeClass('in');
                setTimeout($.proxy(function() {
                    this.popover.css('display', 'none');
                    this.getSearchInput().val('');
                    this.filter(''); // clear filter
                    this._trigger('iconpickerHidden', {
                        iconpickerValue: this.iconpickerValue
                    });
                }, this), this.options.animation ? 300 : 1);
            },
            toggle: function() {
                if (this.popover.is(":visible")) {
                    this.hide();
                } else {
                    this.show(true);
                }
            },
            update: function(val, updateOnlyInternal) {
                val = (val ? val : this.getSourceValue(this.iconpickerValue));
                // reads the input or element value again and tries to update the plugin
                // fallback to the current selected item value
                this._trigger('iconpickerUpdate', {
                    iconpickerValue: this.iconpickerValue
                });

                if (updateOnlyInternal === true) {
                    val = this.setValue(val);
                } else {
                    val = this.setSourceValue(val);
                    this._updateFormGroupStatus(val !== false);
                }

                if (val !== false) {
                    this._updateComponents();
                }

                this._trigger('iconpickerUpdated', {
                    iconpickerValue: this.iconpickerValue
                });
                return val;
            },
            destroy: function() {
                this._trigger('iconpickerDestroy', {
                    iconpickerValue: this.iconpickerValue
                });

                // unbinds events and resets everything to the initial state,
                // including component mode
                this.element.removeData('iconpicker').removeData('iconpickerValue').removeClass('iconpicker-element');

                this._unbindElementEvents();
                this._unbindWindowEvents();

                $(this.popover).remove();

                this._trigger('iconpickerDestroyed', {
                    iconpickerValue: this.iconpickerValue
                });
            },
            disable: function() {
                if (this.hasInput()) {
                    this.input.prop('disabled', true);
                    return true;
                }
                return false;
            },
            enable: function() {
                if (this.hasInput()) {
                    this.input.prop('disabled', false);
                    return true;
                }
                return false;
            },
            isDisabled: function() {
                if (this.hasInput()) {
                    return (this.input.prop('disabled') === true);
                }
                return false;
            },
            isInline: function() {
                return (this.options.placement === 'inline') || (this.popover.hasClass('inline'));
            }
        };

        $.iconpicker = Iconpicker;

        // jQuery plugin
        $.fn.iconpicker = function(options) {
            return this.each(function() {
                var $this = $(this);
                if (!$this.data('iconpicker')) {
                    // create plugin instance (only if not exists) and expose the entire instance API
                    $this.data('iconpicker', new Iconpicker(this, ((typeof options === 'object') ? options : {})));
                }
            });
        };

        // List of all Font Awesome icons without class prefix
        Iconpicker.defaultOptions.icons = [
			{title: "fab fa-500px",searchTerms: ["500px"]},
			{title: "fab fa-accessible-icon",searchTerms: ["accessible icon","aðgengilegt táknið"]},
			{title: "fab fa-accusoft",searchTerms: ["accusoft"]},
			{title: "fas fa-address-book",searchTerms: ["address book","heimilisfangabók"]},
			{title: "far fa-address-book",searchTerms: ["address book","heimilisfangabók"]},
			{title: "fas fa-address-card",searchTerms: ["address card","nafnspjald"]},
			{title: "far fa-address-card",searchTerms: ["address card","nafnspjald"]},
			{title: "fas fa-adjust",searchTerms: ["adjust","stilla"]},
			{title: "fab fa-adn",searchTerms: ["adn"]},
			{title: "fab fa-adversal",searchTerms: ["adversal","andstæða"]},
			{title: "fab fa-affiliatetheme",searchTerms: ["affiliatetheme","samstarfsaðilar"]},
			{title: "fas fa-air-freshener",searchTerms: ["air freshener","loft freshener"]},
			{title: "fab fa-algolia",searchTerms: ["algolia","algólía"]},
			{title: "fas fa-align-center",searchTerms: ["align center","taktu miðju"]},
			{title: "fas fa-align-justify",searchTerms: ["align justify","taktu réttlætingu"]},
			{title: "fas fa-align-left",searchTerms: ["align left","taktu vinstri"]},
			{title: "fas fa-align-right",searchTerms: ["align right","taktu til hægri"]},
			{title: "fas fa-allergies",searchTerms: ["allergies","ofnæmi"]},
			{title: "fab fa-amazon",searchTerms: ["amazon"]},
			{title: "fab fa-amazon-pay",searchTerms: ["amazon pay","Amazon greiða"]},
			{title: "fas fa-ambulance",searchTerms: ["ambulance","sjúkrabíll"]},
			{title: "fas fa-american-sign-language-interpreting",searchTerms: ["american sign language interpreting","American táknmál túlka"]},
			{title: "fab fa-amilia",searchTerms: ["amilia"]},
			{title: "fas fa-anchor",searchTerms: ["anchor","akkeri"]},
			{title: "fab fa-android",searchTerms: ["android"]},
			{title: "fab fa-angellist",searchTerms: ["angellist"]},
			{title: "fas fa-angle-double-down",searchTerms: ["angle double down","horn tvöfalt niður"]},
			{title: "fas fa-angle-double-left",searchTerms: ["angle double left","horn tvöfalt eftir"]},
			{title: "fas fa-angle-double-right",searchTerms: ["angle double right","horn tvöfalt rétt"]},
			{title: "fas fa-angle-double-up",searchTerms: ["angle double up","horn tvöfalt upp"]},
			{title: "fas fa-angle-down",searchTerms: ["angle down","halla niður"]},
			{title: "fas fa-angle-left",searchTerms: ["angle left","horn til vinstri"]},
			{title: "fas fa-angle-right",searchTerms: ["angle right","horn rétt"]},
			{title: "fas fa-angle-up",searchTerms: ["angle up","halla upp"]},
			{title: "fas fa-angry",searchTerms: ["angry","reiður"]},
			{title: "far fa-angry",searchTerms: ["angry","reiður"]},
			{title: "fab fa-angrycreative",searchTerms: ["angrycreative","reiður"]},
			{title: "fab fa-angular",searchTerms: ["angular","hyrndur"]},
			{title: "fab fa-app-store",searchTerms: ["app store","app verslun"]},
			{title: "fab fa-app-store-ios",searchTerms: ["app store ios","App Store Ios"]},
			{title: "fab fa-apper",searchTerms: ["apper","forrit"]},
			{title: "fab fa-apple",searchTerms: ["apple","epli"]},
			{title: "fas fa-apple-alt",searchTerms: ["apple alt","epli allt"]},
			{title: "fab fa-apple-pay",searchTerms: ["apple pay","eplakostnaður"]},
			{title: "fas fa-archive",searchTerms: ["archive","skjalasafn"]},
			{title: "fas fa-archway",searchTerms: ["archway"]},
			{title: "fas fa-arrow-alt-circle-down",searchTerms: ["arrow alt circle down","ör alt hring niður"]},
			{title: "far fa-arrow-alt-circle-down",searchTerms: ["arrow alt circle down","ör alt hring niður"]},
			{title: "fas fa-arrow-alt-circle-left",searchTerms: ["arrow alt circle left","ör altarhringur til vinstri"]},
			{title: "far fa-arrow-alt-circle-left",searchTerms: ["arrow alt circle left","ör altarhringur til vinstri"]},
			{title: "fas fa-arrow-alt-circle-right",searchTerms: ["arrow alt circle right","ör alt hring rétt"]},
			{title: "far fa-arrow-alt-circle-right",searchTerms: ["arrow alt circle right","ör alt hring rétt"]},
			{title: "fas fa-arrow-alt-circle-up",searchTerms: ["arrow alt circle up","ör alt hring upp"]},
			{title: "far fa-arrow-alt-circle-up",searchTerms: ["arrow alt circle up","ör alt hring upp"]},
			{title: "fas fa-arrow-circle-down",searchTerms: ["arrow circle down","ör hringur niður"]},
			{title: "fas fa-arrow-circle-left",searchTerms: ["arrow circle left","örhringur til vinstri"]},
			{title: "fas fa-arrow-circle-right",searchTerms: ["arrow circle right","ör hringur rétt"]},
			{title: "fas fa-arrow-circle-up",searchTerms: ["arrow circle up","ör hringur upp"]},
			{title: "fas fa-arrow-down",searchTerms: ["arrow down","ör niður"]},
			{title: "fas fa-arrow-left",searchTerms: ["arrow left","ör vinstri"]},
			{title: "fas fa-arrow-right",searchTerms: ["arrow right","ör hægri"]},
			{title: "fas fa-arrow-up",searchTerms: ["arrow up","ör upp"]},
			{title: "fas fa-arrows-alt",searchTerms: ["arrows alt","örvar alt"]},
			{title: "fas fa-arrows-alt-h",searchTerms: ["arrows alt h","örvar alt h"]},
			{title: "fas fa-arrows-alt-v",searchTerms: ["arrows alt v","örvar alt v"]},
			{title: "fas fa-assistive-listening-systems",searchTerms: ["assistive listening systems","hjálparstýrikerfi"]},
			{title: "fas fa-asterisk",searchTerms: ["asterisk","stjörnu"]},
			{title: "fab fa-asymmetrik",searchTerms: ["asymmetrik","ósamhverfi"]},
			{title: "fas fa-at",searchTerms: ["at","á"]},
			{title: "fas fa-atlas",searchTerms: ["atlas","Atlas"]},
			{title: "fas fa-atom",searchTerms: ["atom","atóm"]},
			{title: "fab fa-audible",searchTerms: ["audible","heyranlegur"]},
			{title: "fas fa-audio-description",searchTerms: ["audio description","hljóð lýsing"]},
			{title: "fab fa-autoprefixer",searchTerms: ["autoprefixer","autoprefix"]},
			{title: "fab fa-avianex",searchTerms: ["avianex"]},
			{title: "fab fa-aviato",searchTerms: ["aviato"]},
			{title: "fas fa-award",searchTerms: ["award","verðlaun"]},
			{title: "fab fa-aws",searchTerms: ["aws"]},
			{title: "fas fa-backspace",searchTerms: ["backspace"]},
			{title: "fas fa-backward",searchTerms: ["backward","afturábak"]},
			{title: "fas fa-balance-scale",searchTerms: ["balance scale","jafnvægissvið"]},
			{title: "fas fa-ban",searchTerms: ["ban","Ban"]},
			{title: "fas fa-band-aid",searchTerms: ["band aid","plástur"]},
			{title: "fab fa-bandcamp",searchTerms: ["bandcamp"]},
			{title: "fas fa-barcode",searchTerms: ["barcode","strikamerki"]},
			{title: "fas fa-bars",searchTerms: ["bars","barir"]},
			{title: "fas fa-baseball-ball",searchTerms: ["baseball ball","baseball boltinn"]},
			{title: "fas fa-basketball-ball",searchTerms: ["basketball ball","körfubolta bolti"]},
			{title: "fas fa-bath",searchTerms: ["bath","bað"]},
			{title: "fas fa-battery-empty",searchTerms: ["battery empty","rafhlaða tómur"]},
			{title: "fas fa-battery-full",searchTerms: ["battery full","rafhlaðan fullur"]},
			{title: "fas fa-battery-half",searchTerms: ["battery half","rafhlaða hálf"]},
			{title: "fas fa-battery-quarter",searchTerms: ["battery quarter","rafhlaða fjórðungur"]},
			{title: "fas fa-battery-three-quarters",searchTerms: ["battery three quarters","rafhlaða þriggja fjórðu"]},
			{title: "fas fa-bed",searchTerms: ["bed","rúm"]},
			{title: "fas fa-beer",searchTerms: ["beer","bjór"]},
			{title: "fab fa-behance",searchTerms: ["behance"]},
			{title: "fab fa-behance-square",searchTerms: ["behance square"]},
			{title: "fas fa-bell",searchTerms: ["bell","bjalla"]},
			{title: "far fa-bell",searchTerms: ["bell","bjalla"]},
			{title: "fas fa-bell-slash",searchTerms: ["bell slash","bjalla rista"]},
			{title: "far fa-bell-slash",searchTerms: ["bell slash","bjalla rista"]},
			{title: "fas fa-bezier-curve",searchTerms: ["bezier curve","bezier ferillinn"]},
			{title: "fas fa-bicycle",searchTerms: ["bicycle","reiðhjól"]},
			{title: "fab fa-bimobject",searchTerms: ["bimobject"]},
			{title: "fas fa-binoculars",searchTerms: ["binoculars","sjónauka"]},
			{title: "fas fa-birthday-cake",searchTerms: ["birthday cake","afmælis kaka"]},
			{title: "fab fa-bitbucket",searchTerms: ["bitbucket"]},
			{title: "fab fa-bitcoin",searchTerms: ["bitcoin"]},
			{title: "fab fa-bity",searchTerms: ["bity","barinn"]},
			{title: "fab fa-black-tie",searchTerms: ["black tie","svart bindi"]},
			{title: "fab fa-blackberry",searchTerms: ["blackberry","brómber"]},
			{title: "fas fa-blender",searchTerms: ["blender"]},
			{title: "fas fa-blind",searchTerms: ["blind","blindur"]},
			{title: "fab fa-blogger",searchTerms: ["blogger"]},
			{title: "fab fa-blogger-b",searchTerms: ["blogger b"]},
			{title: "fab fa-bluetooth",searchTerms: ["bluetooth","blátönn"]},
			{title: "fab fa-bluetooth-b",searchTerms: ["bluetooth b","Bluetooth b"]},
			{title: "fas fa-bold",searchTerms: ["bold","feitletrað"]},
			{title: "fas fa-bolt",searchTerms: ["bolt","Boltinn"]},
			{title: "fas fa-bomb",searchTerms: ["bomb","sprengju"]},
			{title: "fas fa-bone",searchTerms: ["bone","bein"]},
			{title: "fas fa-bong",searchTerms: ["bong"]},
			{title: "fas fa-book",searchTerms: ["book","bók"]},
			{title: "fas fa-book-open",searchTerms: ["book open","bókin opnuð"]},
			{title: "fas fa-book-reader",searchTerms: ["book reader","bókalesari"]},
			{title: "fas fa-bookmark",searchTerms: ["bookmark","bókamerki"]},
			{title: "far fa-bookmark",searchTerms: ["bookmark","bókamerki"]},
			{title: "fas fa-bowling-ball",searchTerms: ["bowling ball","keilubolti"]},
			{title: "fas fa-box",searchTerms: ["box","kassi"]},
			{title: "fas fa-box-open",searchTerms: ["box open","kassi opinn"]},
			{title: "fas fa-boxes",searchTerms: ["boxes","Kassar"]},
			{title: "fas fa-braille",searchTerms: ["braille","Braille"]},
			{title: "fas fa-brain",searchTerms: ["brain","heila"]},
			{title: "fas fa-briefcase",searchTerms: ["briefcase","skjalataska"]},
			{title: "fas fa-briefcase-medical",searchTerms: ["briefcase medical","skjalataska læknis"]},
			{title: "fas fa-broadcast-tower",searchTerms: ["broadcast tower","útsending turn"]},
			{title: "fas fa-broom",searchTerms: ["broom"]},
			{title: "fas fa-brush",searchTerms: ["brush","bursta"]},
			{title: "fab fa-btc",searchTerms: ["btc"]},
			{title: "fas fa-bug",searchTerms: ["bug","galla"]},
			{title: "fas fa-building",searchTerms: ["building","bygging"]},
			{title: "far fa-building",searchTerms: ["building","bygging"]},
			{title: "fas fa-bullhorn",searchTerms: ["bullhorn"]},
			{title: "fas fa-bullseye",searchTerms: ["bullseye"]},
			{title: "fas fa-burn",searchTerms: ["burn","brenna"]},
			{title: "fab fa-buromobelexperte",searchTerms: ["buromobelexperte"]},
			{title: "fas fa-bus",searchTerms: ["bus","rútu"]},
			{title: "fas fa-bus-alt",searchTerms: ["bus alt","rútu allt"]},
			{title: "fab fa-buysellads",searchTerms: ["buysellads"]},
			{title: "fas fa-calculator",searchTerms: ["calculator","reiknivél"]},
			{title: "fas fa-calendar",searchTerms: ["calendar","dagatal"]},
			{title: "far fa-calendar",searchTerms: ["calendar","dagatal"]},
			{title: "fas fa-calendar-alt",searchTerms: ["calendar alt","dagatal alt"]},
			{title: "far fa-calendar-alt",searchTerms: ["calendar alt","dagatal alt"]},
			{title: "fas fa-calendar-check",searchTerms: ["calendar check","dagbókarskoðun"]},
			{title: "far fa-calendar-check",searchTerms: ["calendar check","dagbókarskoðun"]},
			{title: "fas fa-calendar-minus",searchTerms: ["calendar minus","dagbók mínus"]},
			{title: "far fa-calendar-minus",searchTerms: ["calendar minus","dagbók mínus"]},
			{title: "fas fa-calendar-plus",searchTerms: ["calendar plus","dagbók plús"]},
			{title: "far fa-calendar-plus",searchTerms: ["calendar plus","dagbók plús"]},
			{title: "fas fa-calendar-times",searchTerms: ["calendar times","dagatal sinnum"]},
			{title: "far fa-calendar-times",searchTerms: ["calendar times","dagatal sinnum"]},
			{title: "fas fa-camera",searchTerms: ["camera","myndavél"]},
			{title: "fas fa-camera-retro",searchTerms: ["camera retro","myndavélin aftur"]},
			{title: "fas fa-cannabis",searchTerms: ["cannabis","kannabis"]},
			{title: "fas fa-capsules",searchTerms: ["capsules","hylki"]},
			{title: "fas fa-car",searchTerms: ["car","bíll"]},
			{title: "fas fa-car-alt",searchTerms: ["car alt","bíll alt"]},
			{title: "fas fa-car-battery",searchTerms: ["car battery","bíll rafhlaða"]},
			{title: "fas fa-car-crash",searchTerms: ["car crash","árekstur"]},
			{title: "fas fa-car-side",searchTerms: ["car side","bíllhlið"]},
			{title: "fas fa-caret-down",searchTerms: ["caret down","hylja niður"]},
			{title: "fas fa-caret-left",searchTerms: ["caret left","hylja til vinstri"]},
			{title: "fas fa-caret-right",searchTerms: ["caret right","sæta rétt"]},
			{title: "fas fa-caret-square-down",searchTerms: ["caret square down","Caret ferningur niður"]},
			{title: "far fa-caret-square-down",searchTerms: ["caret square down","Caret ferningur niður"]},
			{title: "fas fa-caret-square-left",searchTerms: ["caret square left","Caret Square til vinstri"]},
			{title: "far fa-caret-square-left",searchTerms: ["caret square left","Caret Square til vinstri"]},
			{title: "fas fa-caret-square-right",searchTerms: ["caret square right","Caret Square rétt"]},
			{title: "far fa-caret-square-right",searchTerms: ["caret square right","Caret Square rétt"]},
			{title: "fas fa-caret-square-up",searchTerms: ["caret square up","Caret ferningur upp"]},
			{title: "far fa-caret-square-up",searchTerms: ["caret square up","Caret ferningur upp"]},
			{title: "fas fa-caret-up",searchTerms: ["caret up","hylja upp"]},
			{title: "fas fa-cart-arrow-down",searchTerms: ["cart arrow down","körfu ör niður"]},
			{title: "fas fa-cart-plus",searchTerms: ["cart plus","körfu plús"]},
			{title: "fab fa-cc-amazon-pay",searchTerms: ["cc amazon pay","cc Amazon greiða"]},
			{title: "fab fa-cc-amex",searchTerms: ["cc amex"]},
			{title: "fab fa-cc-apple-pay",searchTerms: ["cc apple pay","cc eplakostnaður"]},
			{title: "fab fa-cc-diners-club",searchTerms: ["cc diners club","cc dinners club"]},
			{title: "fab fa-cc-discover",searchTerms: ["cc discover","cc uppgötva"]},
			{title: "fab fa-cc-jcb",searchTerms: ["cc jcb"]},
			{title: "fab fa-cc-mastercard",searchTerms: ["cc mastercard"]},
			{title: "fab fa-cc-paypal",searchTerms: ["cc paypal"]},
			{title: "fab fa-cc-stripe",searchTerms: ["cc stripe","cc rönd"]},
			{title: "fab fa-cc-visa",searchTerms: ["cc visa","cc vegabréfsáritun"]},
			{title: "fab fa-centercode",searchTerms: ["centercode","miðstöð"]},
			{title: "fas fa-certificate",searchTerms: ["certificate","vottorð"]},
			{title: "fas fa-chalkboard",searchTerms: ["chalkboard","tafla"]},
			{title: "fas fa-chalkboard-teacher",searchTerms: ["chalkboard teacher","kennara"]},
			{title: "fas fa-charging-station",searchTerms: ["charging station","hleðslustöð"]},
			{title: "fas fa-chart-area",searchTerms: ["chart area","töflu svæði"]},
			{title: "fas fa-chart-bar",searchTerms: ["chart bar","töflu bar"]},
			{title: "far fa-chart-bar",searchTerms: ["chart bar","töflu bar"]},
			{title: "fas fa-chart-line",searchTerms: ["chart line","línurit"]},
			{title: "fas fa-chart-pie",searchTerms: ["chart pie","töflu baka"]},
			{title: "fas fa-check",searchTerms: ["check","athuga"]},
			{title: "fas fa-check-circle",searchTerms: ["check circle","athuga hring"]},
			{title: "far fa-check-circle",searchTerms: ["check circle","athuga hring"]},
			{title: "fas fa-check-double",searchTerms: ["check double","athugaðu tvöfalt"]},
			{title: "fas fa-check-square",searchTerms: ["check square","Athugaðu veldi"]},
			{title: "far fa-check-square",searchTerms: ["check square","Athugaðu veldi"]},
			{title: "fas fa-chess",searchTerms: ["chess","skák"]},
			{title: "fas fa-chess-bishop",searchTerms: ["chess bishop","skák biskup"]},
			{title: "fas fa-chess-board",searchTerms: ["chess board","skákborð"]},
			{title: "fas fa-chess-king",searchTerms: ["chess king","skák konungur"]},
			{title: "fas fa-chess-knight",searchTerms: ["chess knight","skák riddari"]},
			{title: "fas fa-chess-pawn",searchTerms: ["chess pawn","skák peð"]},
			{title: "fas fa-chess-queen",searchTerms: ["chess queen","skák drottning"]},
			{title: "fas fa-chess-rook",searchTerms: ["chess rook","skákþvottur"]},
			{title: "fas fa-chevron-circle-down",searchTerms: ["chevron circle down","Chevron hring niður"]},
			{title: "fas fa-chevron-circle-left",searchTerms: ["chevron circle left","Chevron hringur til vinstri"]},
			{title: "fas fa-chevron-circle-right",searchTerms: ["chevron circle right","Chevron hring rétt"]},
			{title: "fas fa-chevron-circle-up",searchTerms: ["chevron circle up","Chevron hring upp"]},
			{title: "fas fa-chevron-down",searchTerms: ["chevron down","Chevron niður"]},
			{title: "fas fa-chevron-left",searchTerms: ["chevron left","Chevron fór"]},
			{title: "fas fa-chevron-right",searchTerms: ["chevron right","Chevron rétt"]},
			{title: "fas fa-chevron-up",searchTerms: ["chevron up","Chevron upp"]},
			{title: "fas fa-child",searchTerms: ["child","barn"]},
			{title: "fab fa-chrome",searchTerms: ["chrome","króm"]},
			{title: "fas fa-church",searchTerms: ["church","kirkja"]},
			{title: "fas fa-circle",searchTerms: ["circle","hringur"]},
			{title: "far fa-circle",searchTerms: ["circle","hringur"]},
			{title: "fas fa-circle-notch",searchTerms: ["circle notch","hring hak"]},
			{title: "fas fa-clipboard",searchTerms: ["clipboard","klemmuspjald"]},
			{title: "far fa-clipboard",searchTerms: ["clipboard","klemmuspjald"]},
			{title: "fas fa-clipboard-check",searchTerms: ["clipboard check","klemmuspjald stöðva"]},
			{title: "fas fa-clipboard-list",searchTerms: ["clipboard list","klemmuspjaldalista"]},
			{title: "fas fa-clock",searchTerms: ["clock","klukka"]},
			{title: "far fa-clock",searchTerms: ["clock","klukka"]},
			{title: "fas fa-clone",searchTerms: ["clone","klón"]},
			{title: "far fa-clone",searchTerms: ["clone","klón"]},
			{title: "fas fa-closed-captioning",searchTerms: ["closed captioning","lokað yfirskrift"]},
			{title: "far fa-closed-captioning",searchTerms: ["closed captioning","lokað yfirskrift"]},
			{title: "fas fa-cloud",searchTerms: ["cloud","ský"]},
			{title: "fas fa-cloud-download-alt",searchTerms: ["cloud download alt","ský niður alt"]},
			{title: "fas fa-cloud-upload-alt",searchTerms: ["cloud upload alt","ský hala allt"]},
			{title: "fab fa-cloudscale",searchTerms: ["cloudscale"]},
			{title: "fab fa-cloudsmith",searchTerms: ["cloudsmith"]},
			{title: "fab fa-cloudversify",searchTerms: ["cloudversify","skýraútgáfu"]},
			{title: "fas fa-cocktail",searchTerms: ["cocktail","hanastél"]},
			{title: "fas fa-code",searchTerms: ["code","kóða"]},
			{title: "fas fa-code-branch",searchTerms: ["code branch","kóða útibú"]},
			{title: "fab fa-codepen",searchTerms: ["codepen","kóða"]},
			{title: "fab fa-codiepie",searchTerms: ["codiepie"]},
			{title: "fas fa-coffee",searchTerms: ["coffee","kaffi"]},
			{title: "fas fa-cog",searchTerms: ["cog","kúla"]},
			{title: "fas fa-cogs",searchTerms: ["cogs"]},
			{title: "fas fa-coins",searchTerms: ["coins","mynt"]},
			{title: "fas fa-columns",searchTerms: ["columns","dálka"]},
			{title: "fas fa-comment",searchTerms: ["comment","athugasemd"]},
			{title: "far fa-comment",searchTerms: ["comment","athugasemd"]},
			{title: "fas fa-comment-alt",searchTerms: ["comment alt","athugasemd alt"]},
			{title: "far fa-comment-alt",searchTerms: ["comment alt","athugasemd alt"]},
			{title: "fas fa-comment-dots",searchTerms: ["comment dots","athugasemdir punktar"]},
			{title: "far fa-comment-dots",searchTerms: ["comment dots","athugasemdir punktar"]},
			{title: "fas fa-comment-slash",searchTerms: ["comment slash","athugaðu rista"]},
			{title: "fas fa-comments",searchTerms: ["comments","athugasemdir"]},
			{title: "far fa-comments",searchTerms: ["comments","athugasemdir"]},
			{title: "fas fa-compact-disc",searchTerms: ["compact disc","geisladiskur"]},
			{title: "fas fa-compass",searchTerms: ["compass","áttavita"]},
			{title: "far fa-compass",searchTerms: ["compass","áttavita"]},
			{title: "fas fa-compress",searchTerms: ["compress","þjappa"]},
			{title: "fas fa-concierge-bell",searchTerms: ["concierge bell","móttakan bjalla"]},
			{title: "fab fa-connectdevelop",searchTerms: ["connectdevelop","tengslanet"]},
			{title: "fab fa-contao",searchTerms: ["contao"]},
			{title: "fas fa-cookie",searchTerms: ["cookie","kex"]},
			{title: "fas fa-cookie-bite",searchTerms: ["cookie bite","kexbit"]},
			{title: "fas fa-copy",searchTerms: ["copy","afrita"]},
			{title: "far fa-copy",searchTerms: ["copy","afrita"]},
			{title: "fas fa-copyright",searchTerms: ["copyright","höfundarrétti"]},
			{title: "far fa-copyright",searchTerms: ["copyright","höfundarrétti"]},
			{title: "fas fa-couch",searchTerms: ["couch","sófanum"]},
			{title: "fab fa-cpanel",searchTerms: ["cpanel"]},
			{title: "fab fa-creative-commons",searchTerms: ["creative commons","skapandi forsætisráðherra"]},
			{title: "fab fa-creative-commons-by",searchTerms: ["creative commons by","Creative Commons by"]},
			{title: "fab fa-creative-commons-nc",searchTerms: ["creative commons nc","skapandi commons nc"]},
			{title: "fab fa-creative-commons-nc-eu",searchTerms: ["creative commons nc eu","skapandi umboð nc eu"]},
			{title: "fab fa-creative-commons-nc-jp",searchTerms: ["creative commons nc jp","skapandi commons nc jp"]},
			{title: "fab fa-creative-commons-nd",searchTerms: ["creative commons nd","skapandi forsætisráðherra"]},
			{title: "fab fa-creative-commons-pd",searchTerms: ["creative commons pd","skapandi forsætisráðherra pd"]},
			{title: "fab fa-creative-commons-pd-alt",searchTerms: ["creative commons pd alt","skapandi forsætisráðherra pd alt"]},
			{title: "fab fa-creative-commons-remix",searchTerms: ["creative commons remix","Skapandi Commons Remix"]},
			{title: "fab fa-creative-commons-sa",searchTerms: ["creative commons sa","skapandi forsætisráðherra"]},
			{title: "fab fa-creative-commons-sampling",searchTerms: ["creative commons sampling","Sýnishorn í skapandi samhengi"]},
			{title: "fab fa-creative-commons-sampling-plus",searchTerms: ["creative commons sampling plus","Sýnishorn fyrir skapandi hópa"]},
			{title: "fab fa-creative-commons-share",searchTerms: ["creative commons share","Creative Commons deila"]},
			{title: "fas fa-credit-card",searchTerms: ["credit card","kreditkort"]},
			{title: "far fa-credit-card",searchTerms: ["credit card","kreditkort"]},
			{title: "fas fa-crop",searchTerms: ["crop","uppskera"]},
			{title: "fas fa-crop-alt",searchTerms: ["crop alt","ræktu allt"]},
			{title: "fas fa-crosshairs",searchTerms: ["crosshairs"]},
			{title: "fas fa-crow",searchTerms: ["crow","krár"]},
			{title: "fas fa-crown",searchTerms: ["crown","kóróna"]},
			{title: "fab fa-css3",searchTerms: ["css3"]},
			{title: "fab fa-css3-alt",searchTerms: ["css3 alt"]},
			{title: "fas fa-cube",searchTerms: ["cube","teningur"]},
			{title: "fas fa-cubes",searchTerms: ["cubes","teningur"]},
			{title: "fas fa-cut",searchTerms: ["cut","skera"]},
			{title: "fab fa-cuttlefish",searchTerms: ["cuttlefish","smokkfiskur"]},
			{title: "fab fa-d-and-d",searchTerms: ["d and d","d og d"]},
			{title: "fab fa-dashcube",searchTerms: ["dashcube"]},
			{title: "fas fa-database",searchTerms: ["database","gagnagrunnur"]},
			{title: "fas fa-deaf",searchTerms: ["deaf","heyrnarlaus"]},
			{title: "fab fa-delicious",searchTerms: ["delicious","ljúffengur"]},
			{title: "fab fa-deploydog",searchTerms: ["deploydog"]},
			{title: "fab fa-deskpro",searchTerms: ["deskpro"]},
			{title: "fas fa-desktop",searchTerms: ["desktop","skrifborð"]},
			{title: "fab fa-deviantart",searchTerms: ["deviantart"]},
			{title: "fas fa-diagnoses",searchTerms: ["diagnoses","greiningu"]},
			{title: "fas fa-dice",searchTerms: ["dice","teningar"]},
			{title: "fas fa-dice-five",searchTerms: ["dice five","teningar fimm"]},
			{title: "fas fa-dice-four",searchTerms: ["dice four","teningar fjögur"]},
			{title: "fas fa-dice-one",searchTerms: ["dice one","teningar einn"]},
			{title: "fas fa-dice-six",searchTerms: ["dice six","teningar sex"]},
			{title: "fas fa-dice-three",searchTerms: ["dice three","teningar þrjú"]},
			{title: "fas fa-dice-two",searchTerms: ["dice two","teningar tveir"]},
			{title: "fab fa-digg",searchTerms: ["digg"]},
			{title: "fab fa-digital-ocean",searchTerms: ["digital ocean","stafræn haf"]},
			{title: "fas fa-digital-tachograph",searchTerms: ["digital tachograph","stafræna ökuritanum"]},
			{title: "fas fa-directions",searchTerms: ["directions","leiðbeiningar"]},
			{title: "fab fa-discord",searchTerms: ["discord"]},
			{title: "fab fa-discourse",searchTerms: ["discourse","umræðu"]},
			{title: "fas fa-divide",searchTerms: ["divide","skipta"]},
			{title: "fas fa-dizzy",searchTerms: ["dizzy","sundl"]},
			{title: "far fa-dizzy",searchTerms: ["dizzy","sundl"]},
			{title: "fas fa-dna",searchTerms: ["dna"]},
			{title: "fab fa-dochub",searchTerms: ["dochub"]},
			{title: "fab fa-docker",searchTerms: ["docker","bryggju"]},
			{title: "fas fa-dollar-sign",searchTerms: ["dollar sign","dollara skilti"]},
			{title: "fas fa-dolly",searchTerms: ["dolly"]},
			{title: "fas fa-dolly-flatbed",searchTerms: ["dolly flatbed"]},
			{title: "fas fa-donate",searchTerms: ["donate","gefa"]},
			{title: "fas fa-door-closed",searchTerms: ["door closed","hurð lokað"]},
			{title: "fas fa-door-open",searchTerms: ["door open","dyr opna"]},
			{title: "fas fa-dot-circle",searchTerms: ["dot circle","punktur hringur"]},
			{title: "far fa-dot-circle",searchTerms: ["dot circle","punktur hringur"]},
			{title: "fas fa-dove",searchTerms: ["dove","dúfur"]},
			{title: "fas fa-download",searchTerms: ["download","sækja"]},
			{title: "fab fa-draft2digital",searchTerms: ["draft2digital"]},
			{title: "fas fa-drafting-compass",searchTerms: ["drafting compass","teikna áttavita"]},
			{title: "fas fa-draw-polygon",searchTerms: ["draw polygon","teikna marghyrning"]},
			{title: "fab fa-dribbble",searchTerms: ["dribbble"]},
			{title: "fab fa-dribbble-square",searchTerms: ["dribbble square","dribbble veldi"]},
			{title: "fab fa-dropbox",searchTerms: ["dropbox"]},
			{title: "fas fa-drum",searchTerms: ["drum","tromma"]},
			{title: "fas fa-drum-steelpan",searchTerms: ["drum steelpan","trommuspotti"]},
			{title: "fab fa-drupal",searchTerms: ["drupal"]},
			{title: "fas fa-dumbbell",searchTerms: ["dumbbell"]},
			{title: "fab fa-dyalog",searchTerms: ["dyalog","viðræður"]},
			{title: "fab fa-earlybirds",searchTerms: ["earlybirds"]},
			{title: "fab fa-ebay",searchTerms: ["ebay"]},
			{title: "fab fa-edge",searchTerms: ["edge","brún"]},
			{title: "fas fa-edit",searchTerms: ["edit","breyta"]},
			{title: "far fa-edit",searchTerms: ["edit","breyta"]},
			{title: "fas fa-eject",searchTerms: ["eject","skjóta út"]},
			{title: "fab fa-elementor",searchTerms: ["elementor"]},
			{title: "fas fa-ellipsis-h",searchTerms: ["ellipsis h"]},
			{title: "fas fa-ellipsis-v",searchTerms: ["ellipsis v"]},
			{title: "fab fa-ello",searchTerms: ["ello","það"]},
			{title: "fab fa-ember",searchTerms: ["ember","maður"]},
			{title: "fab fa-empire",searchTerms: ["empire","Stórveldi"]},
			{title: "fas fa-envelope",searchTerms: ["envelope","umslag"]},
			{title: "far fa-envelope",searchTerms: ["envelope","umslag"]},
			{title: "fas fa-envelope-open",searchTerms: ["envelope open","umslag opnuð"]},
			{title: "far fa-envelope-open",searchTerms: ["envelope open","umslag opnuð"]},
			{title: "fas fa-envelope-square",searchTerms: ["envelope square","umslagstorg"]},
			{title: "fab fa-envira",searchTerms: ["envira","Ég mun senda"]},
			{title: "fas fa-equals",searchTerms: ["equals","jafngildir"]},
			{title: "fas fa-eraser",searchTerms: ["eraser","strokleður"]},
			{title: "fab fa-erlang",searchTerms: ["erlang"]},
			{title: "fab fa-ethereum",searchTerms: ["ethereum","etereum"]},
			{title: "fab fa-etsy",searchTerms: ["etsy"]},
			{title: "fas fa-euro-sign",searchTerms: ["euro sign","evrur skilti"]},
			{title: "fas fa-exchange-alt",searchTerms: ["exchange alt","skiptast á alt"]},
			{title: "fas fa-exclamation",searchTerms: ["exclamation","upphrópunar"]},
			{title: "fas fa-exclamation-circle",searchTerms: ["exclamation circle","upphrópunarhringur"]},
			{title: "fas fa-exclamation-triangle",searchTerms: ["exclamation triangle","upphrópunar þríhyrningur"]},
			{title: "fas fa-expand",searchTerms: ["expand","auka"]},
			{title: "fas fa-expand-arrows-alt",searchTerms: ["expand arrows alt","stækka örvarnar alt"]},
			{title: "fab fa-expeditedssl",searchTerms: ["expeditedssl","hraða"]},
			{title: "fas fa-external-link-alt",searchTerms: ["external link alt","utanaðkomandi hlekkur alt"]},
			{title: "fas fa-external-link-square-alt",searchTerms: ["external link square alt","ytri tengill ferningur alt"]},
			{title: "fas fa-eye",searchTerms: ["eye","auga"]},
			{title: "far fa-eye",searchTerms: ["eye","auga"]},
			{title: "fas fa-eye-dropper",searchTerms: ["eye dropper","augndropar"]},
			{title: "fas fa-eye-slash",searchTerms: ["eye slash","augnhálsi"]},
			{title: "far fa-eye-slash",searchTerms: ["eye slash","augnhálsi"]},
			{title: "fab fa-facebook",searchTerms: ["facebook","Facebook"]},
			{title: "fab fa-facebook-f",searchTerms: ["facebook f","Facebook f"]},
			{title: "fab fa-facebook-messenger",searchTerms: ["facebook messenger","Facebook boðberi"]},
			{title: "fab fa-facebook-square",searchTerms: ["facebook square","Facebook ferningur"]},
			{title: "fas fa-fast-backward",searchTerms: ["fast backward","hratt afturábak"]},
			{title: "fas fa-fast-forward",searchTerms: ["fast forward","hraðspóla"]},
			{title: "fas fa-fax",searchTerms: ["fax"]},
			{title: "fas fa-feather",searchTerms: ["feather","fjöður"]},
			{title: "fas fa-feather-alt",searchTerms: ["feather alt","fjöður alt"]},
			{title: "fas fa-female",searchTerms: ["female","kvenkyns"]},
			{title: "fas fa-fighter-jet",searchTerms: ["fighter jet","bardagamaður"]},
			{title: "fas fa-file",searchTerms: ["file","skrá"]},
			{title: "far fa-file",searchTerms: ["file","skrá"]},
			{title: "fas fa-file-alt",searchTerms: ["file alt","skrá allt"]},
			{title: "far fa-file-alt",searchTerms: ["file alt","skrá allt"]},
			{title: "fas fa-file-archive",searchTerms: ["file archive","skráasafn"]},
			{title: "far fa-file-archive",searchTerms: ["file archive","skráasafn"]},
			{title: "fas fa-file-audio",searchTerms: ["file audio","skrá hljóð"]},
			{title: "far fa-file-audio",searchTerms: ["file audio","skrá hljóð"]},
			{title: "fas fa-file-code",searchTerms: ["file code","skráarkóði"]},
			{title: "far fa-file-code",searchTerms: ["file code","skráarkóði"]},
			{title: "fas fa-file-contract",searchTerms: ["file contract","skrá samningur"]},
			{title: "fas fa-file-download",searchTerms: ["file download","skrá niðurhal"]},
			{title: "fas fa-file-excel",searchTerms: ["file excel","skrá framúrskarandi"]},
			{title: "far fa-file-excel",searchTerms: ["file excel","skrá framúrskarandi"]},
			{title: "fas fa-file-export",searchTerms: ["file export","skrá útflutningur"]},
			{title: "fas fa-file-image",searchTerms: ["file image","skrá mynd"]},
			{title: "far fa-file-image",searchTerms: ["file image","skrá mynd"]},
			{title: "fas fa-file-import",searchTerms: ["file import","skrá innflutningur"]},
			{title: "fas fa-file-invoice",searchTerms: ["file invoice","skrá reikningur"]},
			{title: "fas fa-file-invoice-dollar",searchTerms: ["file invoice dollar","skráarkostnaður Bandaríkjadals"]},
			{title: "fas fa-file-medical",searchTerms: ["file medical","skrá læknis"]},
			{title: "fas fa-file-medical-alt",searchTerms: ["file medical alt","skrá læknisfræðilega alt"]},
			{title: "fas fa-file-pdf",searchTerms: ["file pdf","skrá pdf"]},
			{title: "far fa-file-pdf",searchTerms: ["file pdf","skrá pdf"]},
			{title: "fas fa-file-powerpoint",searchTerms: ["file powerpoint","skrá powerpoint"]},
			{title: "far fa-file-powerpoint",searchTerms: ["file powerpoint","skrá powerpoint"]},
			{title: "fas fa-file-prescription",searchTerms: ["file prescription","skrá ávísun"]},
			{title: "fas fa-file-signature",searchTerms: ["file signature","skrá undirskrift"]},
			{title: "fas fa-file-upload",searchTerms: ["file upload","skrá upphleðsla"]},
			{title: "fas fa-file-video",searchTerms: ["file video","skrá myndskeið"]},
			{title: "far fa-file-video",searchTerms: ["file video","skrá myndskeið"]},
			{title: "fas fa-file-word",searchTerms: ["file word","skrá orð"]},
			{title: "far fa-file-word",searchTerms: ["file word","skrá orð"]},
			{title: "fas fa-fill",searchTerms: ["fill","Fylla"]},
			{title: "fas fa-fill-drip",searchTerms: ["fill drip","fylltu dreypi"]},
			{title: "fas fa-film",searchTerms: ["film","kvikmynd"]},
			{title: "fas fa-filter",searchTerms: ["filter","sía"]},
			{title: "fas fa-fingerprint",searchTerms: ["fingerprint","fingrafar"]},
			{title: "fas fa-fire",searchTerms: ["fire","eldur"]},
			{title: "fas fa-fire-extinguisher",searchTerms: ["fire extinguisher","slökkvitæki"]},
			{title: "fab fa-firefox",searchTerms: ["firefox","eldur"]},
			{title: "fas fa-first-aid",searchTerms: ["first aid","fyrsta hjálp"]},
			{title: "fab fa-first-order",searchTerms: ["first order","fyrstu röð"]},
			{title: "fab fa-first-order-alt",searchTerms: ["first order alt","fyrsta pöntun alt"]},
			{title: "fab fa-firstdraft",searchTerms: ["firstdraft","fyrsta uppkast"]},
			{title: "fas fa-fish",searchTerms: ["fish","fiskur"]},
			{title: "fas fa-flag",searchTerms: ["flag","fána"]},
			{title: "far fa-flag",searchTerms: ["flag","fána"]},
			{title: "fas fa-flag-checkered",searchTerms: ["flag checkered","flagg köflóttur"]},
			{title: "fas fa-flask",searchTerms: ["flask","flösku"]},
			{title: "fab fa-flickr",searchTerms: ["flickr","Flickr"]},
			{title: "fab fa-flipboard",searchTerms: ["flipboard"]},
			{title: "fas fa-flushed",searchTerms: ["flushed","skola"]},
			{title: "far fa-flushed",searchTerms: ["flushed","skola"]},
			{title: "fab fa-fly",searchTerms: ["fly","fluga"]},
			{title: "fas fa-folder",searchTerms: ["folder","mappa"]},
			{title: "far fa-folder",searchTerms: ["folder","mappa"]},
			{title: "fas fa-folder-open",searchTerms: ["folder open","möppu opinn"]},
			{title: "far fa-folder-open",searchTerms: ["folder open","möppu opinn"]},
			{title: "fas fa-font",searchTerms: ["font","leturgerð"]},
			{title: "fab fa-font-awesome",searchTerms: ["font awesome","letur ógnvekjandi"]},
			{title: "fab fa-font-awesome-alt",searchTerms: ["font awesome alt","letrið frábært alt"]},
			{title: "fab fa-font-awesome-flag",searchTerms: ["font awesome flag","letrið ógnvekjandi fána"]},
			{title: "far fa-font-awesome-logo-full",searchTerms: ["font awesome logo full","letrið frábært merki fullt"]},
			{title: "fas fa-font-awesome-logo-full",searchTerms: ["font awesome logo full","letrið frábært merki fullt"]},
			{title: "fab fa-font-awesome-logo-full",searchTerms: ["font awesome logo full","letrið frábært merki fullt"]},
			{title: "fab fa-fonticons",searchTerms: ["fonticons"]},
			{title: "fab fa-fonticons-fi",searchTerms: ["fonticons fi"]},
			{title: "fas fa-football-ball",searchTerms: ["football ball","fótbolti boltinn"]},
			{title: "fab fa-fort-awesome",searchTerms: ["fort awesome","Fort ógnvekjandi"]},
			{title: "fab fa-fort-awesome-alt",searchTerms: ["fort awesome alt","Fort ógnvekjandi alt"]},
			{title: "fab fa-forumbee",searchTerms: ["forumbee"]},
			{title: "fas fa-forward",searchTerms: ["forward","áfram"]},
			{title: "fab fa-foursquare",searchTerms: ["foursquare"]},
			{title: "fab fa-free-code-camp",searchTerms: ["free code camp","ókeypis kóða Tjaldvagnar"]},
			{title: "fab fa-freebsd",searchTerms: ["freebsd"]},
			{title: "fas fa-frog",searchTerms: ["frog","froskur"]},
			{title: "fas fa-frown",searchTerms: ["frown"]},
			{title: "far fa-frown",searchTerms: ["frown"]},
			{title: "fas fa-frown-open",searchTerms: ["frown open","risið opið"]},
			{title: "far fa-frown-open",searchTerms: ["frown open","risið opið"]},
			{title: "fab fa-fulcrum",searchTerms: ["fulcrum"]},
			{title: "fas fa-futbol",searchTerms: ["futbol","fótbolti"]},
			{title: "far fa-futbol",searchTerms: ["futbol","fótbolti"]},
			{title: "fab fa-galactic-republic",searchTerms: ["galactic republic","Galactic Republic"]},
			{title: "fab fa-galactic-senate",searchTerms: ["galactic senate","Galactic Senate"]},
			{title: "fas fa-gamepad",searchTerms: ["gamepad"]},
			{title: "fas fa-gas-pump",searchTerms: ["gas pump","gasdæla"]},
			{title: "fas fa-gavel",searchTerms: ["gavel"]},
			{title: "fas fa-gem",searchTerms: ["gem"]},
			{title: "far fa-gem",searchTerms: ["gem"]},
			{title: "fas fa-genderless",searchTerms: ["genderless","kynlaus"]},
			{title: "fab fa-get-pocket",searchTerms: ["get pocket","fá vasa"]},
			{title: "fab fa-gg",searchTerms: ["gg"]},
			{title: "fab fa-gg-circle",searchTerms: ["gg circle","gg hring"]},
			{title: "fas fa-gift",searchTerms: ["gift","gjöf"]},
			{title: "fab fa-git",searchTerms: ["git"]},
			{title: "fab fa-git-square",searchTerms: ["git square"]},
			{title: "fab fa-github",searchTerms: ["github"]},
			{title: "fab fa-github-alt",searchTerms: ["github alt"]},
			{title: "fab fa-github-square",searchTerms: ["github square","github torginu"]},
			{title: "fab fa-gitkraken",searchTerms: ["gitkraken","sprunga"]},
			{title: "fab fa-gitlab",searchTerms: ["gitlab","fara"]},
			{title: "fab fa-gitter",searchTerms: ["gitter","rist"]},
			{title: "fas fa-glass-martini",searchTerms: ["glass martini","gler martini"]},
			{title: "fas fa-glass-martini-alt",searchTerms: ["glass martini alt","gler martini alt"]},
			{title: "fas fa-glasses",searchTerms: ["glasses","gleraugu"]},
			{title: "fab fa-glide",searchTerms: ["glide","renna"]},
			{title: "fab fa-glide-g",searchTerms: ["glide g","renna g"]},
			{title: "fas fa-globe",searchTerms: ["globe","heimurinn"]},
			{title: "fas fa-globe-africa",searchTerms: ["globe africa","heimurinn Afríku"]},
			{title: "fas fa-globe-americas",searchTerms: ["globe americas","Ameríku heimsins"]},
			{title: "fas fa-globe-asia",searchTerms: ["globe asia","heimurinn Asíu"]},
			{title: "fab fa-gofore",searchTerms: ["gofore","fyrirfram"]},
			{title: "fas fa-golf-ball",searchTerms: ["golf ball","golfbolti"]},
			{title: "fab fa-goodreads",searchTerms: ["goodreads"]},
			{title: "fab fa-goodreads-g",searchTerms: ["goodreads g","g"]},
			{title: "fab fa-google",searchTerms: ["google"]},
			{title: "fab fa-google-drive",searchTerms: ["google drive","google drif"]},
			{title: "fab fa-google-play",searchTerms: ["google play","google leika"]},
			{title: "fab fa-google-plus",searchTerms: ["google plus","google plús"]},
			{title: "fab fa-google-plus-g",searchTerms: ["google plus g","google plús g"]},
			{title: "fab fa-google-plus-square",searchTerms: ["google plus square","google plús ferningur"]},
			{title: "fab fa-google-wallet",searchTerms: ["google wallet","google veski"]},
			{title: "fas fa-graduation-cap",searchTerms: ["graduation cap","útskriftapoki"]},
			{title: "fab fa-gratipay",searchTerms: ["gratipay"]},
			{title: "fab fa-grav",searchTerms: ["grav","alvarleg"]},
			{title: "fas fa-greater-than",searchTerms: ["greater than","meiri en"]},
			{title: "fas fa-greater-than-equal",searchTerms: ["greater than equal","meiri en jafn"]},
			{title: "fas fa-grimace",searchTerms: ["grimace"]},
			{title: "far fa-grimace",searchTerms: ["grimace"]},
			{title: "fas fa-grin",searchTerms: ["grin"]},
			{title: "far fa-grin",searchTerms: ["grin"]},
			{title: "fas fa-grin-alt",searchTerms: ["grin alt","hlæja öllu"]},
			{title: "far fa-grin-alt",searchTerms: ["grin alt","hlæja öllu"]},
			{title: "fas fa-grin-beam",searchTerms: ["grin beam","grín geisla"]},
			{title: "far fa-grin-beam",searchTerms: ["grin beam","grín geisla"]},
			{title: "fas fa-grin-beam-sweat",searchTerms: ["grin beam sweat","grín geisla svita"]},
			{title: "far fa-grin-beam-sweat",searchTerms: ["grin beam sweat","grín geisla svita"]},
			{title: "fas fa-grin-hearts",searchTerms: ["grin hearts","grín hjörtu"]},
			{title: "far fa-grin-hearts",searchTerms: ["grin hearts","grín hjörtu"]},
			{title: "fas fa-grin-squint",searchTerms: ["grin squint"]},
			{title: "far fa-grin-squint",searchTerms: ["grin squint"]},
			{title: "fas fa-grin-squint-tears",searchTerms: ["grin squint tears","grin squint tár"]},
			{title: "far fa-grin-squint-tears",searchTerms: ["grin squint tears","grin squint tár"]},
			{title: "fas fa-grin-stars",searchTerms: ["grin stars","grín stjörnur"]},
			{title: "far fa-grin-stars",searchTerms: ["grin stars","grín stjörnur"]},
			{title: "fas fa-grin-tears",searchTerms: ["grin tears","grín tár"]},
			{title: "far fa-grin-tears",searchTerms: ["grin tears","grín tár"]},
			{title: "fas fa-grin-tongue",searchTerms: ["grin tongue","grin tunga"]},
			{title: "far fa-grin-tongue",searchTerms: ["grin tongue","grin tunga"]},
			{title: "fas fa-grin-tongue-squint",searchTerms: ["grin tongue squint","grin tunga squint"]},
			{title: "far fa-grin-tongue-squint",searchTerms: ["grin tongue squint","grin tunga squint"]},
			{title: "fas fa-grin-tongue-wink",searchTerms: ["grin tongue wink","grin tungu wink"]},
			{title: "far fa-grin-tongue-wink",searchTerms: ["grin tongue wink","grin tungu wink"]},
			{title: "fas fa-grin-wink",searchTerms: ["grin wink"]},
			{title: "far fa-grin-wink",searchTerms: ["grin wink"]},
			{title: "fas fa-grip-horizontal",searchTerms: ["grip horizontal","grip lárétt"]},
			{title: "fas fa-grip-vertical",searchTerms: ["grip vertical","grip lóðrétt"]},
			{title: "fab fa-gripfire",searchTerms: ["gripfire"]},
			{title: "fab fa-grunt",searchTerms: ["grunt"]},
			{title: "fab fa-gulp",searchTerms: ["gulp"]},
			{title: "fas fa-h-square",searchTerms: ["h square","h fermetra"]},
			{title: "fab fa-hacker-news",searchTerms: ["hacker news","spjallþráð fréttir"]},
			{title: "fab fa-hacker-news-square",searchTerms: ["hacker news square","tölvusnápur fréttir"]},
			{title: "fab fa-hackerrank",searchTerms: ["hackerrank"]},
			{title: "fas fa-hand-holding",searchTerms: ["hand holding","hönd halda"]},
			{title: "fas fa-hand-holding-heart",searchTerms: ["hand holding heart","hönd halda hjarta"]},
			{title: "fas fa-hand-holding-usd",searchTerms: ["hand holding usd","hönd halda usd"]},
			{title: "fas fa-hand-lizard",searchTerms: ["hand lizard","hönd leðri"]},
			{title: "far fa-hand-lizard",searchTerms: ["hand lizard","hönd leðri"]},
			{title: "fas fa-hand-paper",searchTerms: ["hand paper","handpappír"]},
			{title: "far fa-hand-paper",searchTerms: ["hand paper","handpappír"]},
			{title: "fas fa-hand-peace",searchTerms: ["hand peace","hönd friði"]},
			{title: "far fa-hand-peace",searchTerms: ["hand peace","hönd friði"]},
			{title: "fas fa-hand-point-down",searchTerms: ["hand point down","hönd benda niður"]},
			{title: "far fa-hand-point-down",searchTerms: ["hand point down","hönd benda niður"]},
			{title: "fas fa-hand-point-left",searchTerms: ["hand point left","hönd benda til vinstri"]},
			{title: "far fa-hand-point-left",searchTerms: ["hand point left","hönd benda til vinstri"]},
			{title: "fas fa-hand-point-right",searchTerms: ["hand point right","hönd benda til hægri"]},
			{title: "far fa-hand-point-right",searchTerms: ["hand point right","hönd benda til hægri"]},
			{title: "fas fa-hand-point-up",searchTerms: ["hand point up","hönd benda á"]},
			{title: "far fa-hand-point-up",searchTerms: ["hand point up","hönd benda á"]},
			{title: "fas fa-hand-pointer",searchTerms: ["hand pointer","hendi bendillinn"]},
			{title: "far fa-hand-pointer",searchTerms: ["hand pointer","hendi bendillinn"]},
			{title: "fas fa-hand-rock",searchTerms: ["hand rock","hönd klettur"]},
			{title: "far fa-hand-rock",searchTerms: ["hand rock","hönd klettur"]},
			{title: "fas fa-hand-scissors",searchTerms: ["hand scissors","hönd skæri"]},
			{title: "far fa-hand-scissors",searchTerms: ["hand scissors","hönd skæri"]},
			{title: "fas fa-hand-spock",searchTerms: ["hand spock","hönd spock"]},
			{title: "far fa-hand-spock",searchTerms: ["hand spock","hönd spock"]},
			{title: "fas fa-hands",searchTerms: ["hands","hendur"]},
			{title: "fas fa-hands-helping",searchTerms: ["hands helping","hendur hjálpa"]},
			{title: "fas fa-handshake",searchTerms: ["handshake"]},
			{title: "far fa-handshake",searchTerms: ["handshake"]},
			{title: "fas fa-hashtag",searchTerms: ["hashtag","kassamerki"]},
			{title: "fas fa-hdd",searchTerms: ["hdd"]},
			{title: "far fa-hdd",searchTerms: ["hdd"]},
			{title: "fas fa-heading",searchTerms: ["heading","fyrirsögn"]},
			{title: "fas fa-headphones",searchTerms: ["headphones","heyrnartól"]},
			{title: "fas fa-headphones-alt",searchTerms: ["headphones alt","heyrnartól alt"]},
			{title: "fas fa-headset",searchTerms: ["headset","heyrnartól"]},
			{title: "fas fa-heart",searchTerms: ["heart","hjarta"]},
			{title: "far fa-heart",searchTerms: ["heart","hjarta"]},
			{title: "fas fa-heartbeat",searchTerms: ["heartbeat","hjartsláttur"]},
			{title: "fas fa-helicopter",searchTerms: ["helicopter","þyrla"]},
			{title: "fas fa-highlighter",searchTerms: ["highlighter","hápunktur"]},
			{title: "fab fa-hips",searchTerms: ["hips","mjöðmum"]},
			{title: "fab fa-hire-a-helper",searchTerms: ["hire a helper","ráða hjálpar"]},
			{title: "fas fa-history",searchTerms: ["history","saga"]},
			{title: "fas fa-hockey-puck",searchTerms: ["hockey puck","Hockey Puck"]},
			{title: "fas fa-home",searchTerms: ["home","heim"]},
			{title: "fab fa-hooli",searchTerms: ["hooli","umönnun"]},
			{title: "fab fa-hornbill",searchTerms: ["hornbill","Hornbill"]},
			{title: "fas fa-hospital",searchTerms: ["hospital","sjúkrahús"]},
			{title: "far fa-hospital",searchTerms: ["hospital","sjúkrahús"]},
			{title: "fas fa-hospital-alt",searchTerms: ["hospital alt","sjúkrahús allt"]},
			{title: "fas fa-hospital-symbol",searchTerms: ["hospital symbol","sjúkrahús tákn"]},
			{title: "fas fa-hot-tub",searchTerms: ["hot tub","heitur pottur"]},
			{title: "fas fa-hotel",searchTerms: ["hotel","hótel"]},
			{title: "fab fa-hotjar",searchTerms: ["hotjar","að slappa af"]},
			{title: "fas fa-hourglass",searchTerms: ["hourglass","klukkustund"]},
			{title: "far fa-hourglass",searchTerms: ["hourglass","klukkustund"]},
			{title: "fas fa-hourglass-end",searchTerms: ["hourglass end","klukkustund enda"]},
			{title: "fas fa-hourglass-half",searchTerms: ["hourglass half","klukkustund hálf"]},
			{title: "fas fa-hourglass-start",searchTerms: ["hourglass start","klukkustund byrjun"]},
			{title: "fab fa-houzz",searchTerms: ["houzz","Houzz"]},
			{title: "fab fa-html5",searchTerms: ["html5"]},
			{title: "fab fa-hubspot",searchTerms: ["hubspot"]},
			{title: "fas fa-i-cursor",searchTerms: ["i cursor","ég bendillinn"]},
			{title: "fas fa-id-badge",searchTerms: ["id badge","kennimerki"]},
			{title: "far fa-id-badge",searchTerms: ["id badge","kennimerki"]},
			{title: "fas fa-id-card",searchTerms: ["id card","skilríki"]},
			{title: "far fa-id-card",searchTerms: ["id card","skilríki"]},
			{title: "fas fa-id-card-alt",searchTerms: ["id card alt","ID kort alt"]},
			{title: "fas fa-image",searchTerms: ["image","mynd"]},
			{title: "far fa-image",searchTerms: ["image","mynd"]},
			{title: "fas fa-images",searchTerms: ["images","myndir"]},
			{title: "far fa-images",searchTerms: ["images","myndir"]},
			{title: "fab fa-imdb",searchTerms: ["imdb"]},
			{title: "fas fa-inbox",searchTerms: ["inbox","innhólf"]},
			{title: "fas fa-indent",searchTerms: ["indent","inndráttur"]},
			{title: "fas fa-industry",searchTerms: ["industry","iðnaður"]},
			{title: "fas fa-infinity",searchTerms: ["infinity","óendanlegt"]},
			{title: "fas fa-info",searchTerms: ["info","upplýsingar"]},
			{title: "fas fa-info-circle",searchTerms: ["info circle","upplýsingar hring"]},
			{title: "fab fa-instagram",searchTerms: ["instagram"]},
			{title: "fab fa-internet-explorer",searchTerms: ["internet explorer","Internet Explorer"]},
			{title: "fab fa-ioxhost",searchTerms: ["ioxhost"]},
			{title: "fas fa-italic",searchTerms: ["italic","skáletrað"]},
			{title: "fab fa-itunes",searchTerms: ["itunes","iTunes"]},
			{title: "fab fa-itunes-note",searchTerms: ["itunes note","iTunes athugasemd"]},
			{title: "fab fa-java",searchTerms: ["java","Java"]},
			{title: "fab fa-jedi-order",searchTerms: ["jedi order","Jedi röð"]},
			{title: "fab fa-jenkins",searchTerms: ["jenkins"]},
			{title: "fab fa-joget",searchTerms: ["joget","skokka"]},
			{title: "fas fa-joint",searchTerms: ["joint","sameiginlegt"]},
			{title: "fab fa-joomla",searchTerms: ["joomla"]},
			{title: "fab fa-js",searchTerms: ["js"]},
			{title: "fab fa-js-square",searchTerms: ["js square","js ferningur"]},
			{title: "fab fa-jsfiddle",searchTerms: ["jsfiddle"]},
			{title: "fab fa-kaggle",searchTerms: ["kaggle"]},
			{title: "fas fa-key",searchTerms: ["key","lykillinn"]},
			{title: "fab fa-keybase",searchTerms: ["keybase"]},
			{title: "fas fa-keyboard",searchTerms: ["keyboard","lyklaborð"]},
			{title: "far fa-keyboard",searchTerms: ["keyboard","lyklaborð"]},
			{title: "fab fa-keycdn",searchTerms: ["keycdn"]},
			{title: "fab fa-kickstarter",searchTerms: ["kickstarter"]},
			{title: "fab fa-kickstarter-k",searchTerms: ["kickstarter k"]},
			{title: "fas fa-kiss",searchTerms: ["kiss","koss"]},
			{title: "far fa-kiss",searchTerms: ["kiss","koss"]},
			{title: "fas fa-kiss-beam",searchTerms: ["kiss beam","koss geisla"]},
			{title: "far fa-kiss-beam",searchTerms: ["kiss beam","koss geisla"]},
			{title: "fas fa-kiss-wink-heart",searchTerms: ["kiss wink heart","koss wink hjarta"]},
			{title: "far fa-kiss-wink-heart",searchTerms: ["kiss wink heart","koss wink hjarta"]},
			{title: "fas fa-kiwi-bird",searchTerms: ["kiwi bird","kiwi fugl"]},
			{title: "fab fa-korvue",searchTerms: ["korvue"]},
			{title: "fas fa-language",searchTerms: ["language","tungumál"]},
			{title: "fas fa-laptop",searchTerms: ["laptop","fartölvu"]},
			{title: "fas fa-laptop-code",searchTerms: ["laptop code","laptop númer"]},
			{title: "fab fa-laravel",searchTerms: ["laravel"]},
			{title: "fab fa-lastfm",searchTerms: ["lastfm"]},
			{title: "fab fa-lastfm-square",searchTerms: ["lastfm square","lastfm torginu"]},
			{title: "fas fa-laugh",searchTerms: ["laugh","hlátur"]},
			{title: "far fa-laugh",searchTerms: ["laugh","hlátur"]},
			{title: "fas fa-laugh-beam",searchTerms: ["laugh beam","hlæja geisla"]},
			{title: "far fa-laugh-beam",searchTerms: ["laugh beam","hlæja geisla"]},
			{title: "fas fa-laugh-squint",searchTerms: ["laugh squint","hlæðu hreint"]},
			{title: "far fa-laugh-squint",searchTerms: ["laugh squint","hlæðu hreint"]},
			{title: "fas fa-laugh-wink",searchTerms: ["laugh wink","hlæðu wink"]},
			{title: "far fa-laugh-wink",searchTerms: ["laugh wink","hlæðu wink"]},
			{title: "fas fa-layer-group",searchTerms: ["layer group","lagahópur"]},
			{title: "fas fa-leaf",searchTerms: ["leaf","blaða"]},
			{title: "fab fa-leanpub",searchTerms: ["leanpub"]},
			{title: "fas fa-lemon",searchTerms: ["lemon","sítrónu"]},
			{title: "far fa-lemon",searchTerms: ["lemon","sítrónu"]},
			{title: "fab fa-less",searchTerms: ["less","minna"]},
			{title: "fas fa-less-than",searchTerms: ["less than","minna en"]},
			{title: "fas fa-less-than-equal",searchTerms: ["less than equal","minna en jafnt"]},
			{title: "fas fa-level-down-alt",searchTerms: ["level down alt","stig niður alt"]},
			{title: "fas fa-level-up-alt",searchTerms: ["level up alt","stig allt upp"]},
			{title: "fas fa-life-ring",searchTerms: ["life ring","lífhringur"]},
			{title: "far fa-life-ring",searchTerms: ["life ring","lífhringur"]},
			{title: "fas fa-lightbulb",searchTerms: ["lightbulb","ljósapera"]},
			{title: "far fa-lightbulb",searchTerms: ["lightbulb","ljósapera"]},
			{title: "fab fa-line",searchTerms: ["line","lína"]},
			{title: "fas fa-link",searchTerms: ["link","hlekkur"]},
			{title: "fab fa-linkedin",searchTerms: ["linkedin"]},
			{title: "fab fa-linkedin-in",searchTerms: ["linkedin in","linkedin"]},
			{title: "fab fa-linode",searchTerms: ["linode","línódein"]},
			{title: "fab fa-linux",searchTerms: ["linux"]},
			{title: "fas fa-lira-sign",searchTerms: ["lira sign","Lira tákn"]},
			{title: "fas fa-list",searchTerms: ["list","listi"]},
			{title: "fas fa-list-alt",searchTerms: ["list alt","lista allt"]},
			{title: "far fa-list-alt",searchTerms: ["list alt","lista allt"]},
			{title: "fas fa-list-ol",searchTerms: ["list ol","lista ol"]},
			{title: "fas fa-list-ul",searchTerms: ["list ul","listi ul"]},
			{title: "fas fa-location-arrow",searchTerms: ["location arrow","staðsetning ör"]},
			{title: "fas fa-lock",searchTerms: ["lock","læsa"]},
			{title: "fas fa-lock-open",searchTerms: ["lock open","látið opna"]},
			{title: "fas fa-long-arrow-alt-down",searchTerms: ["long arrow alt down","langur ör alt niður"]},
			{title: "fas fa-long-arrow-alt-left",searchTerms: ["long arrow alt left","langur ör altur eftir"]},
			{title: "fas fa-long-arrow-alt-right",searchTerms: ["long arrow alt right","langur ör, allt í lagi"]},
			{title: "fas fa-long-arrow-alt-up",searchTerms: ["long arrow alt up","langur ör allt upp"]},
			{title: "fas fa-low-vision",searchTerms: ["low vision","lágt sýn"]},
			{title: "fas fa-luggage-cart",searchTerms: ["luggage cart","farangursvagn"]},
			{title: "fab fa-lyft",searchTerms: ["lyft","lyfta"]},
			{title: "fab fa-magento",searchTerms: ["magento","Magento"]},
			{title: "fas fa-magic",searchTerms: ["magic","galdur"]},
			{title: "fas fa-magnet",searchTerms: ["magnet","segull"]},
			{title: "fab fa-mailchimp",searchTerms: ["mailchimp"]},
			{title: "fas fa-male",searchTerms: ["male","karlkyns"]},
			{title: "fab fa-mandalorian",searchTerms: ["mandalorian","Mandalorian"]},
			{title: "fas fa-map",searchTerms: ["map","kort"]},
			{title: "far fa-map",searchTerms: ["map","kort"]},
			{title: "fas fa-map-marked",searchTerms: ["map marked","kort merkt"]},
			{title: "fas fa-map-marked-alt",searchTerms: ["map marked alt","kort merkt alt"]},
			{title: "fas fa-map-marker",searchTerms: ["map marker","kortamerki"]},
			{title: "fas fa-map-marker-alt",searchTerms: ["map marker alt","kortið merkið allt"]},
			{title: "fas fa-map-pin",searchTerms: ["map pin","kortapinnan"]},
			{title: "fas fa-map-signs",searchTerms: ["map signs","kort merki"]},
			{title: "fab fa-markdown",searchTerms: ["markdown"]},
			{title: "fas fa-marker",searchTerms: ["marker","merki"]},
			{title: "fas fa-mars",searchTerms: ["mars"]},
			{title: "fas fa-mars-double",searchTerms: ["mars double","Mars tvöfalt"]},
			{title: "fas fa-mars-stroke",searchTerms: ["mars stroke","Mars heilablóðfall"]},
			{title: "fas fa-mars-stroke-h",searchTerms: ["mars stroke h","Mars heilablóðfall h"]},
			{title: "fas fa-mars-stroke-v",searchTerms: ["mars stroke v","Mars heilablóðfall v"]},
			{title: "fab fa-mastodon",searchTerms: ["mastodon"]},
			{title: "fab fa-maxcdn",searchTerms: ["maxcdn"]},
			{title: "fas fa-medal",searchTerms: ["medal","verðlaun"]},
			{title: "fab fa-medapps",searchTerms: ["medapps","meðapps"]},
			{title: "fab fa-medium",searchTerms: ["medium","miðlungs"]},
			{title: "fab fa-medium-m",searchTerms: ["medium m","miðlungs m"]},
			{title: "fas fa-medkit",searchTerms: ["medkit"]},
			{title: "fab fa-medrt",searchTerms: ["medrt"]},
			{title: "fab fa-meetup",searchTerms: ["meetup","hittast"]},
			{title: "fab fa-megaport",searchTerms: ["megaport","mega höfn"]},
			{title: "fas fa-meh",searchTerms: ["meh"]},
			{title: "far fa-meh",searchTerms: ["meh"]},
			{title: "fas fa-meh-blank",searchTerms: ["meh blank","Meh blank"]},
			{title: "far fa-meh-blank",searchTerms: ["meh blank","Meh blank"]},
			{title: "fas fa-meh-rolling-eyes",searchTerms: ["meh rolling eyes","meh rúllandi augu"]},
			{title: "far fa-meh-rolling-eyes",searchTerms: ["meh rolling eyes","meh rúllandi augu"]},
			{title: "fas fa-memory",searchTerms: ["memory","minni"]},
			{title: "fas fa-mercury",searchTerms: ["mercury","kvikasilfur"]},
			{title: "fas fa-microchip",searchTerms: ["microchip"]},
			{title: "fas fa-microphone",searchTerms: ["microphone","hljóðnemi"]},
			{title: "fas fa-microphone-alt",searchTerms: ["microphone alt","hljóðnemi alt"]},
			{title: "fas fa-microphone-alt-slash",searchTerms: ["microphone alt slash","hljóðnemi allt rista"]},
			{title: "fas fa-microphone-slash",searchTerms: ["microphone slash","hljóðnemi"]},
			{title: "fas fa-microscope",searchTerms: ["microscope","smásjá"]},
			{title: "fab fa-microsoft",searchTerms: ["microsoft","Microsoft"]},
			{title: "fas fa-minus",searchTerms: ["minus","mínus"]},
			{title: "fas fa-minus-circle",searchTerms: ["minus circle","mínus hring"]},
			{title: "fas fa-minus-square",searchTerms: ["minus square","mínus ferningur"]},
			{title: "far fa-minus-square",searchTerms: ["minus square","mínus ferningur"]},
			{title: "fab fa-mix",searchTerms: ["mix","blanda"]},
			{title: "fab fa-mixcloud",searchTerms: ["mixcloud"]},
			{title: "fab fa-mizuni",searchTerms: ["mizuni"]},
			{title: "fas fa-mobile",searchTerms: ["mobile","farsíma"]},
			{title: "fas fa-mobile-alt",searchTerms: ["mobile alt","farsíma allt"]},
			{title: "fab fa-modx",searchTerms: ["modx"]},
			{title: "fab fa-monero",searchTerms: ["monero","mynt"]},
			{title: "fas fa-money-bill",searchTerms: ["money bill","peningakostnaður"]},
			{title: "fas fa-money-bill-alt",searchTerms: ["money bill alt","peningakostnaður alt"]},
			{title: "far fa-money-bill-alt",searchTerms: ["money bill alt","peningakostnaður alt"]},
			{title: "fas fa-money-bill-wave",searchTerms: ["money bill wave","peninga reikningur bylgja"]},
			{title: "fas fa-money-bill-wave-alt",searchTerms: ["money bill wave alt","peninga reikningur bylgja alt"]},
			{title: "fas fa-money-check",searchTerms: ["money check","peningarskoðun"]},
			{title: "fas fa-money-check-alt",searchTerms: ["money check alt","peninga athuga allt"]},
			{title: "fas fa-monument",searchTerms: ["monument","minnismerki"]},
			{title: "fas fa-moon",searchTerms: ["moon","tungl"]},
			{title: "far fa-moon",searchTerms: ["moon","tungl"]},
			{title: "fas fa-mortar-pestle",searchTerms: ["mortar pestle","steypuhræra"]},
			{title: "fas fa-motorcycle",searchTerms: ["motorcycle","Mótorhjól"]},
			{title: "fas fa-mouse-pointer",searchTerms: ["mouse pointer","músarbendillinn"]},
			{title: "fas fa-music",searchTerms: ["music","tónlist"]},
			{title: "fab fa-napster",searchTerms: ["napster"]},
			{title: "fab fa-neos",searchTerms: ["neos"]},
			{title: "fas fa-neuter",searchTerms: ["neuter"]},
			{title: "fas fa-newspaper",searchTerms: ["newspaper","dagblað"]},
			{title: "far fa-newspaper",searchTerms: ["newspaper","dagblað"]},
			{title: "fab fa-nimblr",searchTerms: ["nimblr"]},
			{title: "fab fa-nintendo-switch",searchTerms: ["nintendo switch","nintendo rofi"]},
			{title: "fab fa-node",searchTerms: ["node","hnút"]},
			{title: "fab fa-node-js",searchTerms: ["node js","hnút js"]},
			{title: "fas fa-not-equal",searchTerms: ["not equal","ekki jafnt"]},
			{title: "fas fa-notes-medical",searchTerms: ["notes medical","skýringar læknis"]},
			{title: "fab fa-npm",searchTerms: ["npm","ys"]},
			{title: "fab fa-ns8",searchTerms: ["ns8"]},
			{title: "fab fa-nutritionix",searchTerms: ["nutritionix","næringarblanda"]},
			{title: "fas fa-object-group",searchTerms: ["object group","hluthópur"]},
			{title: "far fa-object-group",searchTerms: ["object group","hluthópur"]},
			{title: "fas fa-object-ungroup",searchTerms: ["object ungroup","mótmæla ungroup"]},
			{title: "far fa-object-ungroup",searchTerms: ["object ungroup","mótmæla ungroup"]},
			{title: "fab fa-odnoklassniki",searchTerms: ["odnoklassniki"]},
			{title: "fab fa-odnoklassniki-square",searchTerms: ["odnoklassniki square","odnoklassniki ferningur"]},
			{title: "fas fa-oil-can",searchTerms: ["oil can","olíudós"]},
			{title: "fab fa-old-republic",searchTerms: ["old republic","gamla lýðveldið"]},
			{title: "fab fa-opencart",searchTerms: ["opencart"]},
			{title: "fab fa-openid",searchTerms: ["openid"]},
			{title: "fab fa-opera",searchTerms: ["opera","ópera"]},
			{title: "fab fa-optin-monster",searchTerms: ["optin monster","optin skrímsli"]},
			{title: "fab fa-osi",searchTerms: ["osi","ás"]},
			{title: "fas fa-outdent",searchTerms: ["outdent"]},
			{title: "fab fa-page4",searchTerms: ["page4"]},
			{title: "fab fa-pagelines",searchTerms: ["pagelines"]},
			{title: "fas fa-paint-brush",searchTerms: ["paint brush","málningabursti"]},
			{title: "fas fa-paint-roller",searchTerms: ["paint roller","mála vals"]},
			{title: "fas fa-palette",searchTerms: ["palette","stiku"]},
			{title: "fab fa-palfed",searchTerms: ["palfed"]},
			{title: "fas fa-pallet",searchTerms: ["pallet","bretti"]},
			{title: "fas fa-paper-plane",searchTerms: ["paper plane","pappír flugvél"]},
			{title: "far fa-paper-plane",searchTerms: ["paper plane","pappír flugvél"]},
			{title: "fas fa-paperclip",searchTerms: ["paperclip","bréfaklemma"]},
			{title: "fas fa-parachute-box",searchTerms: ["parachute box","fallhlíf kassi"]},
			{title: "fas fa-paragraph",searchTerms: ["paragraph","málsgrein"]},
			{title: "fas fa-parking",searchTerms: ["parking","bílastæði"]},
			{title: "fas fa-passport",searchTerms: ["passport","vegabréf"]},
			{title: "fas fa-paste",searchTerms: ["paste","líma"]},
			{title: "fab fa-patreon",searchTerms: ["patreon"]},
			{title: "fas fa-pause",searchTerms: ["pause","hlé"]},
			{title: "fas fa-pause-circle",searchTerms: ["pause circle","hlé hringur"]},
			{title: "far fa-pause-circle",searchTerms: ["pause circle","hlé hringur"]},
			{title: "fas fa-paw",searchTerms: ["paw"]},
			{title: "fab fa-paypal",searchTerms: ["paypal"]},
			{title: "fas fa-pen",searchTerms: ["pen","penni"]},
			{title: "fas fa-pen-alt",searchTerms: ["pen alt","penni allt"]},
			{title: "fas fa-pen-fancy",searchTerms: ["pen fancy","penna ímynda sér"]},
			{title: "fas fa-pen-nib",searchTerms: ["pen nib","penna nib"]},
			{title: "fas fa-pen-square",searchTerms: ["pen square","penna torginu"]},
			{title: "fas fa-pencil-alt",searchTerms: ["pencil alt","blýantur alt"]},
			{title: "fas fa-pencil-ruler",searchTerms: ["pencil ruler","blýantur"]},
			{title: "fas fa-people-carry",searchTerms: ["people carry","fólk ber"]},
			{title: "fas fa-percent",searchTerms: ["percent","prósent"]},
			{title: "fas fa-percentage",searchTerms: ["percentage","hlutfall"]},
			{title: "fab fa-periscope",searchTerms: ["periscope"]},
			{title: "fab fa-phabricator",searchTerms: ["phabricator","tækjabúnaður"]},
			{title: "fab fa-phoenix-framework",searchTerms: ["phoenix framework","Phoenix ramma"]},
			{title: "fab fa-phoenix-squadron",searchTerms: ["phoenix squadron","Phoenix Squadron"]},
			{title: "fas fa-phone",searchTerms: ["phone","sími"]},
			{title: "fas fa-phone-slash",searchTerms: ["phone slash","síma rista"]},
			{title: "fas fa-phone-square",searchTerms: ["phone square","símafyrirtæki"]},
			{title: "fas fa-phone-volume",searchTerms: ["phone volume","sími bindi"]},
			{title: "fab fa-php",searchTerms: ["php"]},
			{title: "fab fa-pied-piper",searchTerms: ["pied piper","fótur piper"]},
			{title: "fab fa-pied-piper-alt",searchTerms: ["pied piper alt","pied piper allt"]},
			{title: "fab fa-pied-piper-hat",searchTerms: ["pied piper hat","pied piper hattur"]},
			{title: "fab fa-pied-piper-pp",searchTerms: ["pied piper pp"]},
			{title: "fas fa-piggy-bank",searchTerms: ["piggy bank","sparibaukur"]},
			{title: "fas fa-pills",searchTerms: ["pills","töflur"]},
			{title: "fab fa-pinterest",searchTerms: ["pinterest","Pinterest"]},
			{title: "fab fa-pinterest-p",searchTerms: ["pinterest p"]},
			{title: "fab fa-pinterest-square",searchTerms: ["pinterest square","pinterest torginu"]},
			{title: "fas fa-plane",searchTerms: ["plane","flugvél"]},
			{title: "fas fa-plane-arrival",searchTerms: ["plane arrival","flugvél komu"]},
			{title: "fas fa-plane-departure",searchTerms: ["plane departure","flugvél brottför"]},
			{title: "fas fa-play",searchTerms: ["play","leika"]},
			{title: "fas fa-play-circle",searchTerms: ["play circle","spila hring"]},
			{title: "far fa-play-circle",searchTerms: ["play circle","spila hring"]},
			{title: "fab fa-playstation",searchTerms: ["playstation","Play Station"]},
			{title: "fas fa-plug",searchTerms: ["plug","stinga"]},
			{title: "fas fa-plus",searchTerms: ["plus","plús"]},
			{title: "fas fa-plus-circle",searchTerms: ["plus circle","auk hring"]},
			{title: "fas fa-plus-square",searchTerms: ["plus square","plús ferningur"]},
			{title: "far fa-plus-square",searchTerms: ["plus square","plús ferningur"]},
			{title: "fas fa-podcast",searchTerms: ["podcast"]},
			{title: "fas fa-poo",searchTerms: ["poo","púði"]},
			{title: "fas fa-poop",searchTerms: ["poop","kúkur"]},
			{title: "fas fa-portrait",searchTerms: ["portrait","portrett"]},
			{title: "fas fa-pound-sign",searchTerms: ["pound sign","pund skilti"]},
			{title: "fas fa-power-off",searchTerms: ["power off","Slökkva á"]},
			{title: "fas fa-prescription",searchTerms: ["prescription","lyfseðil"]},
			{title: "fas fa-prescription-bottle",searchTerms: ["prescription bottle","lyfseðilsflaska"]},
			{title: "fas fa-prescription-bottle-alt",searchTerms: ["prescription bottle alt","lyfseðilsflaska alt"]},
			{title: "fas fa-print",searchTerms: ["print","prenta"]},
			{title: "fas fa-procedures",searchTerms: ["procedures","verklagsreglur"]},
			{title: "fab fa-product-hunt",searchTerms: ["product hunt","vöruleit"]},
			{title: "fas fa-project-diagram",searchTerms: ["project diagram","verkefnisskýring"]},
			{title: "fab fa-pushed",searchTerms: ["pushed","ýtt"]},
			{title: "fas fa-puzzle-piece",searchTerms: ["puzzle piece","ráðgáta stykki"]},
			{title: "fab fa-python",searchTerms: ["python"]},
			{title: "fab fa-qq",searchTerms: ["qq"]},
			{title: "fas fa-qrcode",searchTerms: ["qrcode"]},
			{title: "fas fa-question",searchTerms: ["question","spurning"]},
			{title: "fas fa-question-circle",searchTerms: ["question circle","spurningahringur"]},
			{title: "far fa-question-circle",searchTerms: ["question circle","spurningahringur"]},
			{title: "fas fa-quidditch",searchTerms: ["quidditch"]},
			{title: "fab fa-quinscape",searchTerms: ["quinscape"]},
			{title: "fab fa-quora",searchTerms: ["quora"]},
			{title: "fas fa-quote-left",searchTerms: ["quote left","vitna til vinstri"]},
			{title: "fas fa-quote-right",searchTerms: ["quote right","Tilvitnun rétt"]},
			{title: "fab fa-r-project",searchTerms: ["r project","r verkefni"]},
			{title: "fas fa-random",searchTerms: ["random","handahófi"]},
			{title: "fab fa-ravelry",searchTerms: ["ravelry"]},
			{title: "fab fa-react",searchTerms: ["react","bregðast við"]},
			{title: "fab fa-readme",searchTerms: ["readme"]},
			{title: "fab fa-rebel",searchTerms: ["rebel","uppreisnarmaður"]},
			{title: "fas fa-receipt",searchTerms: ["receipt","kvittun"]},
			{title: "fas fa-recycle",searchTerms: ["recycle","endurvinna"]},
			{title: "fab fa-red-river",searchTerms: ["red river","rauður áin"]},
			{title: "fab fa-reddit",searchTerms: ["reddit"]},
			{title: "fab fa-reddit-alien",searchTerms: ["reddit alien","reddit framandi"]},
			{title: "fab fa-reddit-square",searchTerms: ["reddit square","reddit torginu"]},
			{title: "fas fa-redo",searchTerms: ["redo","endurtaka"]},
			{title: "fas fa-redo-alt",searchTerms: ["redo alt","endurtaka allt"]},
			{title: "fas fa-registered",searchTerms: ["registered","skráð"]},
			{title: "far fa-registered",searchTerms: ["registered","skráð"]},
			{title: "fab fa-rendact",searchTerms: ["rendact","Rendact"]},
			{title: "fab fa-renren",searchTerms: ["renren","Renren"]},
			{title: "fas fa-reply",searchTerms: ["reply","svara"]},
			{title: "fas fa-reply-all",searchTerms: ["reply all","svara öllum"]},
			{title: "fab fa-replyd",searchTerms: ["replyd","svara"]},
			{title: "fab fa-researchgate",searchTerms: ["researchgate"]},
			{title: "fab fa-resolving",searchTerms: ["resolving","leysa"]},
			{title: "fas fa-retweet",searchTerms: ["retweet"]},
			{title: "fab fa-rev",searchTerms: ["rev"]},
			{title: "fas fa-ribbon",searchTerms: ["ribbon","borði"]},
			{title: "fas fa-road",searchTerms: ["road","vegur"]},
			{title: "fas fa-robot",searchTerms: ["robot","vélmenni"]},
			{title: "fas fa-rocket",searchTerms: ["rocket","eldflaugar"]},
			{title: "fab fa-rocketchat",searchTerms: ["rocketchat"]},
			{title: "fab fa-rockrms",searchTerms: ["rockrms"]},
			{title: "fas fa-route",searchTerms: ["route","leið"]},
			{title: "fas fa-rss",searchTerms: ["rss"]},
			{title: "fas fa-rss-square",searchTerms: ["rss square","rss torginu"]},
			{title: "fas fa-ruble-sign",searchTerms: ["ruble sign","rúbla skilti"]},
			{title: "fas fa-ruler",searchTerms: ["ruler","höfðingja"]},
			{title: "fas fa-ruler-combined",searchTerms: ["ruler combined","stjórnandi sameinað"]},
			{title: "fas fa-ruler-horizontal",searchTerms: ["ruler horizontal","Höfðingi lárétt"]},
			{title: "fas fa-ruler-vertical",searchTerms: ["ruler vertical","lóðrétt lóðrétt"]},
			{title: "fas fa-rupee-sign",searchTerms: ["rupee sign","rúpíutákn"]},
			{title: "fas fa-sad-cry",searchTerms: ["sad cry","sorglegt gráta"]},
			{title: "far fa-sad-cry",searchTerms: ["sad cry","sorglegt gráta"]},
			{title: "fas fa-sad-tear",searchTerms: ["sad tear","sorglegt tár"]},
			{title: "far fa-sad-tear",searchTerms: ["sad tear","sorglegt tár"]},
			{title: "fab fa-safari",searchTerms: ["safari"]},
			{title: "fab fa-sass",searchTerms: ["sass"]},
			{title: "fas fa-save",searchTerms: ["save","vista"]},
			{title: "far fa-save",searchTerms: ["save","vista"]},
			{title: "fab fa-schlix",searchTerms: ["schlix"]},
			{title: "fas fa-school",searchTerms: ["school","skóla"]},
			{title: "fas fa-screwdriver",searchTerms: ["screwdriver","skrúfjárn"]},
			{title: "fab fa-scribd",searchTerms: ["scribd","Scribd"]},
			{title: "fas fa-search",searchTerms: ["search","leit"]},
			{title: "fas fa-search-minus",searchTerms: ["search minus","leita mínus"]},
			{title: "fas fa-search-plus",searchTerms: ["search plus","leita plús"]},
			{title: "fab fa-searchengin",searchTerms: ["searchengin"]},
			{title: "fas fa-seedling",searchTerms: ["seedling","plöntur"]},
			{title: "fab fa-sellcast",searchTerms: ["sellcast"]},
			{title: "fab fa-sellsy",searchTerms: ["sellsy"]},
			{title: "fas fa-server",searchTerms: ["server","miðlari"]},
			{title: "fab fa-servicestack",searchTerms: ["servicestack","þjónustustaður"]},
			{title: "fas fa-shapes",searchTerms: ["shapes","form"]},
			{title: "fas fa-share",searchTerms: ["share","deila"]},
			{title: "fas fa-share-alt",searchTerms: ["share alt","deila öllu"]},
			{title: "fas fa-share-alt-square",searchTerms: ["share alt square","deila alt ferningur"]},
			{title: "fas fa-share-square",searchTerms: ["share square","deila ferningi"]},
			{title: "far fa-share-square",searchTerms: ["share square","deila ferningi"]},
			{title: "fas fa-shekel-sign",searchTerms: ["shekel sign","Síklalisti"]},
			{title: "fas fa-shield-alt",searchTerms: ["shield alt","skjöldur alt"]},
			{title: "fas fa-ship",searchTerms: ["ship","skip"]},
			{title: "fas fa-shipping-fast",searchTerms: ["shipping fast","siglinga hratt"]},
			{title: "fab fa-shirtsinbulk",searchTerms: ["shirtsinbulk"]},
			{title: "fas fa-shoe-prints",searchTerms: ["shoe prints","skór prenta"]},
			{title: "fas fa-shopping-bag",searchTerms: ["shopping bag","innkaupapoki"]},
			{title: "fas fa-shopping-basket",searchTerms: ["shopping basket","Innkaupakarfa"]},
			{title: "fas fa-shopping-cart",searchTerms: ["shopping cart","innkaupakerra"]},
			{title: "fab fa-shopware",searchTerms: ["shopware"]},
			{title: "fas fa-shower",searchTerms: ["shower","sturtu"]},
			{title: "fas fa-shuttle-van",searchTerms: ["shuttle van","skutla van"]},
			{title: "fas fa-sign",searchTerms: ["sign","undirrita"]},
			{title: "fas fa-sign-in-alt",searchTerms: ["sign in alt","Skráðu þig inn alt"]},
			{title: "fas fa-sign-language",searchTerms: ["sign language","táknmál"]},
			{title: "fas fa-sign-out-alt",searchTerms: ["sign out alt","Skráðu þig út alt"]},
			{title: "fas fa-signal",searchTerms: ["signal","merki"]},
			{title: "fas fa-signature",searchTerms: ["signature","undirskrift"]},
			{title: "fab fa-simplybuilt",searchTerms: ["simplybuilt","einfaldlega byggð"]},
			{title: "fab fa-sistrix",searchTerms: ["sistrix","SISTRIX"]},
			{title: "fas fa-sitemap",searchTerms: ["sitemap"]},
			{title: "fab fa-sith",searchTerms: ["sith"]},
			{title: "fas fa-skull",searchTerms: ["skull","höfuðkúpa"]},
			{title: "fab fa-skyatlas",searchTerms: ["skyatlas"]},
			{title: "fab fa-skype",searchTerms: ["skype"]},
			{title: "fab fa-slack",searchTerms: ["slack","slaki"]},
			{title: "fab fa-slack-hash",searchTerms: ["slack hash","slaka kjötkássa"]},
			{title: "fas fa-sliders-h",searchTerms: ["sliders h","renna h"]},
			{title: "fab fa-slideshare",searchTerms: ["slideshare"]},
			{title: "fas fa-smile",searchTerms: ["smile","bros"]},
			{title: "far fa-smile",searchTerms: ["smile","bros"]},
			{title: "fas fa-smile-beam",searchTerms: ["smile beam","bros geisla"]},
			{title: "far fa-smile-beam",searchTerms: ["smile beam","bros geisla"]},
			{title: "fas fa-smile-wink",searchTerms: ["smile wink","brosa wink"]},
			{title: "far fa-smile-wink",searchTerms: ["smile wink","brosa wink"]},
			{title: "fas fa-smoking",searchTerms: ["smoking","reykingar"]},
			{title: "fas fa-smoking-ban",searchTerms: ["smoking ban","reykingarbann"]},
			{title: "fab fa-snapchat",searchTerms: ["snapchat","Snapchat"]},
			{title: "fab fa-snapchat-ghost",searchTerms: ["snapchat ghost","Snapchat draugur"]},
			{title: "fab fa-snapchat-square",searchTerms: ["snapchat square","snapchat torginu"]},
			{title: "fas fa-snowflake",searchTerms: ["snowflake","snjókorn"]},
			{title: "far fa-snowflake",searchTerms: ["snowflake","snjókorn"]},
			{title: "fas fa-solar-panel",searchTerms: ["solar panel","sól spjaldið"]},
			{title: "fas fa-sort",searchTerms: ["sort","tegund"]},
			{title: "fas fa-sort-alpha-down",searchTerms: ["sort alpha down","veldu alfa niður"]},
			{title: "fas fa-sort-alpha-up",searchTerms: ["sort alpha up","tegund alfa upp"]},
			{title: "fas fa-sort-amount-down",searchTerms: ["sort amount down","raða upphæð niður"]},
			{title: "fas fa-sort-amount-up",searchTerms: ["sort amount up","raða upphæð"]},
			{title: "fas fa-sort-down",searchTerms: ["sort down","raða niður"]},
			{title: "fas fa-sort-numeric-down",searchTerms: ["sort numeric down","raða tölunni niður"]},
			{title: "fas fa-sort-numeric-up",searchTerms: ["sort numeric up","raða tölunni upp"]},
			{title: "fas fa-sort-up",searchTerms: ["sort up","raða upp"]},
			{title: "fab fa-soundcloud",searchTerms: ["soundcloud"]},
			{title: "fas fa-spa",searchTerms: ["spa"]},
			{title: "fas fa-space-shuttle",searchTerms: ["space shuttle","rúta"]},
			{title: "fab fa-speakap",searchTerms: ["speakap","talkap"]},
			{title: "fas fa-spinner",searchTerms: ["spinner"]},
			{title: "fas fa-splotch",searchTerms: ["splotch"]},
			{title: "fab fa-spotify",searchTerms: ["spotify"]},
			{title: "fas fa-spray-can",searchTerms: ["spray can","úða getur"]},
			{title: "fas fa-square",searchTerms: ["square","ferningur"]},
			{title: "far fa-square",searchTerms: ["square","ferningur"]},
			{title: "fas fa-square-full",searchTerms: ["square full","ferningur fullur"]},
			{title: "fab fa-squarespace",searchTerms: ["squarespace"]},
			{title: "fab fa-stack-exchange",searchTerms: ["stack exchange","stafla skipti"]},
			{title: "fab fa-stack-overflow",searchTerms: ["stack overflow","stafla flæða"]},
			{title: "fas fa-stamp",searchTerms: ["stamp","Stimpill"]},
			{title: "fas fa-star",searchTerms: ["star","stjörnu"]},
			{title: "far fa-star",searchTerms: ["star","stjörnu"]},
			{title: "fas fa-star-half",searchTerms: ["star half","stjörnu helmingur"]},
			{title: "far fa-star-half",searchTerms: ["star half","stjörnu helmingur"]},
			{title: "fas fa-star-half-alt",searchTerms: ["star half alt","stjörnu helmingur allt"]},
			{title: "fas fa-star-of-life",searchTerms: ["star of life","stjörnu í lífinu"]},
			{title: "fab fa-staylinked",searchTerms: ["staylinked"]},
			{title: "fab fa-steam",searchTerms: ["steam","gufu"]},
			{title: "fab fa-steam-square",searchTerms: ["steam square","gufu torg"]},
			{title: "fab fa-steam-symbol",searchTerms: ["steam symbol","gufu tákn"]},
			{title: "fas fa-step-backward",searchTerms: ["step backward","skref afturábak"]},
			{title: "fas fa-step-forward",searchTerms: ["step forward","skref fram á við"]},
			{title: "fas fa-stethoscope",searchTerms: ["stethoscope","þrengsli"]},
			{title: "fab fa-sticker-mule",searchTerms: ["sticker mule","límmiða mule"]},
			{title: "fas fa-sticky-note",searchTerms: ["sticky note","minnismiði"]},
			{title: "far fa-sticky-note",searchTerms: ["sticky note","minnismiði"]},
			{title: "fas fa-stop",searchTerms: ["stop","stöðva"]},
			{title: "fas fa-stop-circle",searchTerms: ["stop circle","stöðva hring"]},
			{title: "far fa-stop-circle",searchTerms: ["stop circle","stöðva hring"]},
			{title: "fas fa-stopwatch",searchTerms: ["stopwatch","skeiðklukku"]},
			{title: "fas fa-store",searchTerms: ["store","verslun"]},
			{title: "fas fa-store-alt",searchTerms: ["store alt","frábært allt"]},
			{title: "fab fa-strava",searchTerms: ["strava","matur"]},
			{title: "fas fa-stream",searchTerms: ["stream","straumur"]},
			{title: "fas fa-street-view",searchTerms: ["street view","strætissýn"]},
			{title: "fas fa-strikethrough",searchTerms: ["strikethrough","framlengingu"]},
			{title: "fab fa-stripe",searchTerms: ["stripe","rönd"]},
			{title: "fab fa-stripe-s",searchTerms: ["stripe s","rendur"]},
			{title: "fas fa-stroopwafel",searchTerms: ["stroopwafel","síróp vöffla"]},
			{title: "fab fa-studiovinari",searchTerms: ["studiovinari"]},
			{title: "fab fa-stumbleupon",searchTerms: ["stumbleupon","rekast á"]},
			{title: "fab fa-stumbleupon-circle",searchTerms: ["stumbleupon circle","stumbleupon hring"]},
			{title: "fas fa-subscript",searchTerms: ["subscript","áskrift"]},
			{title: "fas fa-subway",searchTerms: ["subway","neðanjarðarlest"]},
			{title: "fas fa-suitcase",searchTerms: ["suitcase","ferðatösku"]},
			{title: "fas fa-suitcase-rolling",searchTerms: ["suitcase rolling","ferðatösku veltingur"]},
			{title: "fas fa-sun",searchTerms: ["sun","sól"]},
			{title: "far fa-sun",searchTerms: ["sun","sól"]},
			{title: "fab fa-superpowers",searchTerms: ["superpowers","stórveldi"]},
			{title: "fas fa-superscript",searchTerms: ["superscript"]},
			{title: "fab fa-supple",searchTerms: ["supple","sléttur"]},
			{title: "fas fa-surprise",searchTerms: ["surprise","óvart"]},
			{title: "far fa-surprise",searchTerms: ["surprise","óvart"]},
			{title: "fas fa-swatchbook",searchTerms: ["swatchbook"]},
			{title: "fas fa-swimmer",searchTerms: ["swimmer","sundmaður"]},
			{title: "fas fa-swimming-pool",searchTerms: ["swimming pool","sundlaug"]},
			{title: "fas fa-sync",searchTerms: ["sync","samstilla"]},
			{title: "fas fa-sync-alt",searchTerms: ["sync alt"]},
			{title: "fas fa-syringe",searchTerms: ["syringe","sprauta"]},
			{title: "fas fa-table",searchTerms: ["table","borð"]},
			{title: "fas fa-table-tennis",searchTerms: ["table tennis","borðtennis"]},
			{title: "fas fa-tablet",searchTerms: ["tablet","tafla"]},
			{title: "fas fa-tablet-alt",searchTerms: ["tablet alt","tafla allt"]},
			{title: "fas fa-tablets",searchTerms: ["tablets","töflur"]},
			{title: "fas fa-tachometer-alt",searchTerms: ["tachometer alt","gírmælir alt"]},
			{title: "fas fa-tag",searchTerms: ["tag"]},
			{title: "fas fa-tags",searchTerms: ["tags"]},
			{title: "fas fa-tape",searchTerms: ["tape","borði"]},
			{title: "fas fa-tasks",searchTerms: ["tasks","verkefni"]},
			{title: "fas fa-taxi",searchTerms: ["taxi","leigubíl"]},
			{title: "fab fa-teamspeak",searchTerms: ["teamspeak","liðspeak"]},
			{title: "fas fa-teeth",searchTerms: ["teeth","tennur"]},
			{title: "fas fa-teeth-open",searchTerms: ["teeth open","tennur opnar"]},
			{title: "fab fa-telegram",searchTerms: ["telegram","símskeyti"]},
			{title: "fab fa-telegram-plane",searchTerms: ["telegram plane","fjarskiptatæki"]},
			{title: "fab fa-tencent-weibo",searchTerms: ["tencent weibo"]},
			{title: "fas fa-terminal",searchTerms: ["terminal","flugstöðinni"]},
			{title: "fas fa-text-height",searchTerms: ["text height","texti hæð"]},
			{title: "fas fa-text-width",searchTerms: ["text width","texti breidd"]},
			{title: "fas fa-th",searchTerms: ["th"]},
			{title: "fas fa-th-large",searchTerms: ["th large","th stór"]},
			{title: "fas fa-th-list",searchTerms: ["th list","th listanum"]},
			{title: "fas fa-theater-masks",searchTerms: ["theater masks","leikhús grímur"]},
			{title: "fab fa-themeco",searchTerms: ["themeco"]},
			{title: "fab fa-themeisle",searchTerms: ["themeisle","þema"]},
			{title: "fas fa-thermometer",searchTerms: ["thermometer","hitamælir"]},
			{title: "fas fa-thermometer-empty",searchTerms: ["thermometer empty","hitamælir tómur"]},
			{title: "fas fa-thermometer-full",searchTerms: ["thermometer full","hitamælir fullur"]},
			{title: "fas fa-thermometer-half",searchTerms: ["thermometer half","hitamælir helmingur"]},
			{title: "fas fa-thermometer-quarter",searchTerms: ["thermometer quarter","hitamælir fjórðungur"]},
			{title: "fas fa-thermometer-three-quarters",searchTerms: ["thermometer three quarters","hitamælir þrír fjórðu"]},
			{title: "fas fa-thumbs-down",searchTerms: ["thumbs down","þumlar niður"]},
			{title: "far fa-thumbs-down",searchTerms: ["thumbs down","þumlar niður"]},
			{title: "fas fa-thumbs-up",searchTerms: ["thumbs up","þumalfingur upp"]},
			{title: "far fa-thumbs-up",searchTerms: ["thumbs up","þumalfingur upp"]},
			{title: "fas fa-thumbtack",searchTerms: ["thumbtack"]},
			{title: "fas fa-ticket-alt",searchTerms: ["ticket alt","miða alt"]},
			{title: "fas fa-times",searchTerms: ["times","tímum"]},
			{title: "fas fa-times-circle",searchTerms: ["times circle","tímar hringur"]},
			{title: "far fa-times-circle",searchTerms: ["times circle","tímar hringur"]},
			{title: "fas fa-tint",searchTerms: ["tint","litbrigði"]},
			{title: "fas fa-tint-slash",searchTerms: ["tint slash","tint skvetta"]},
			{title: "fas fa-tired",searchTerms: ["tired","þreyttur"]},
			{title: "far fa-tired",searchTerms: ["tired","þreyttur"]},
			{title: "fas fa-toggle-off",searchTerms: ["toggle off","slökkva á"]},
			{title: "fas fa-toggle-on",searchTerms: ["toggle on","kveikja á"]},
			{title: "fas fa-toolbox",searchTerms: ["toolbox","verkfæri"]},
			{title: "fas fa-tooth",searchTerms: ["tooth","tönn"]},
			{title: "fab fa-trade-federation",searchTerms: ["trade federation","samtök"]},
			{title: "fas fa-trademark",searchTerms: ["trademark","vörumerki"]},
			{title: "fas fa-traffic-light",searchTerms: ["traffic light","umferðarljós"]},
			{title: "fas fa-train",searchTerms: ["train","lest"]},
			{title: "fas fa-transgender",searchTerms: ["transgender"]},
			{title: "fas fa-transgender-alt",searchTerms: ["transgender alt","transgender allt"]},
			{title: "fas fa-trash",searchTerms: ["trash","rusl"]},
			{title: "fas fa-trash-alt",searchTerms: ["trash alt","rusl allt"]},
			{title: "far fa-trash-alt",searchTerms: ["trash alt","rusl allt"]},
			{title: "fas fa-tree",searchTerms: ["tree","tré"]},
			{title: "fab fa-trello",searchTerms: ["trello","Trello"]},
			{title: "fab fa-tripadvisor",searchTerms: ["tripadvisor"]},
			{title: "fas fa-trophy",searchTerms: ["trophy","bikarkeppni"]},
			{title: "fas fa-truck",searchTerms: ["truck","vörubíll"]},
			{title: "fas fa-truck-loading",searchTerms: ["truck loading","hleðsla vörubíla"]},
			{title: "fas fa-truck-monster",searchTerms: ["truck monster","vörubíll skrímsli"]},
			{title: "fas fa-truck-moving",searchTerms: ["truck moving","vörubíll flutningur"]},
			{title: "fas fa-truck-pickup",searchTerms: ["truck pickup","vörubíll pallbíll"]},
			{title: "fas fa-tshirt",searchTerms: ["tshirt","stuttermabolur"]},
			{title: "fas fa-tty",searchTerms: ["tty"]},
			{title: "fab fa-tumblr",searchTerms: ["tumblr"]},
			{title: "fab fa-tumblr-square",searchTerms: ["tumblr square","tumblr torginu"]},
			{title: "fas fa-tv",searchTerms: ["tv","sjónvarp"]},
			{title: "fab fa-twitch",searchTerms: ["twitch","rísa"]},
			{title: "fab fa-twitter",searchTerms: ["twitter","kvak"]},
			{title: "fab fa-twitter-square",searchTerms: ["twitter square","twitter ferningur"]},
			{title: "fab fa-typo3",searchTerms: ["typo3"]},
			{title: "fab fa-uber",searchTerms: ["uber"]},
			{title: "fab fa-uikit",searchTerms: ["uikit"]},
			{title: "fas fa-umbrella",searchTerms: ["umbrella","regnhlíf"]},
			{title: "fas fa-umbrella-beach",searchTerms: ["umbrella beach","regnhlíf ströndinni"]},
			{title: "fas fa-underline",searchTerms: ["underline","undirstrika"]},
			{title: "fas fa-undo",searchTerms: ["undo","afturkalla"]},
			{title: "fas fa-undo-alt",searchTerms: ["undo alt","afturkalla allt"]},
			{title: "fab fa-uniregistry",searchTerms: ["uniregistry"]},
			{title: "fas fa-universal-access",searchTerms: ["universal access","alhliða aðgang"]},
			{title: "fas fa-university",searchTerms: ["university","háskóli"]},
			{title: "fas fa-unlink",searchTerms: ["unlink","aftengja"]},
			{title: "fas fa-unlock",searchTerms: ["unlock","opna"]},
			{title: "fas fa-unlock-alt",searchTerms: ["unlock alt","opna alt"]},
			{title: "fab fa-untappd",searchTerms: ["untappd"]},
			{title: "fas fa-upload",searchTerms: ["upload","senda inn"]},
			{title: "fab fa-usb",searchTerms: ["usb","USB"]},
			{title: "fas fa-user",searchTerms: ["user","notandi"]},
			{title: "far fa-user",searchTerms: ["user","notandi"]},
			{title: "fas fa-user-alt",searchTerms: ["user alt","notandi alt"]},
			{title: "fas fa-user-alt-slash",searchTerms: ["user alt slash","notandi allt rista"]},
			{title: "fas fa-user-astronaut",searchTerms: ["user astronaut","notandi geimfari"]},
			{title: "fas fa-user-check",searchTerms: ["user check","notendakönnun"]},
			{title: "fas fa-user-circle",searchTerms: ["user circle","notendahringur"]},
			{title: "far fa-user-circle",searchTerms: ["user circle","notendahringur"]},
			{title: "fas fa-user-clock",searchTerms: ["user clock","notandi klukka"]},
			{title: "fas fa-user-cog",searchTerms: ["user cog","notendahópur"]},
			{title: "fas fa-user-edit",searchTerms: ["user edit","breyta notanda"]},
			{title: "fas fa-user-friends",searchTerms: ["user friends","notandi vinir"]},
			{title: "fas fa-user-graduate",searchTerms: ["user graduate","notandi útskrifast"]},
			{title: "fas fa-user-lock",searchTerms: ["user lock","notendalás"]},
			{title: "fas fa-user-md",searchTerms: ["user md","notandi md"]},
			{title: "fas fa-user-minus",searchTerms: ["user minus","notandi mínus"]},
			{title: "fas fa-user-ninja",searchTerms: ["user ninja","notandi ninja"]},
			{title: "fas fa-user-plus",searchTerms: ["user plus","notandi plús"]},
			{title: "fas fa-user-secret",searchTerms: ["user secret","notendaleyndarmál"]},
			{title: "fas fa-user-shield",searchTerms: ["user shield","notandi skjöldur"]},
			{title: "fas fa-user-slash",searchTerms: ["user slash","notandi rista"]},
			{title: "fas fa-user-tag",searchTerms: ["user tag","notendakóði"]},
			{title: "fas fa-user-tie",searchTerms: ["user tie","notendahópur"]},
			{title: "fas fa-user-times",searchTerms: ["user times","notendatímar"]},
			{title: "fas fa-users",searchTerms: ["users","notendur"]},
			{title: "fas fa-users-cog",searchTerms: ["users cog","notendur cog"]},
			{title: "fab fa-ussunnah",searchTerms: ["ussunnah"]},
			{title: "fas fa-utensil-spoon",searchTerms: ["utensil spoon","áhöld skeið"]},
			{title: "fas fa-utensils",searchTerms: ["utensils","áhöld"]},
			{title: "fab fa-vaadin",searchTerms: ["vaadin","ég hélt"]},
			{title: "fas fa-vector-square",searchTerms: ["vector square","vektor veldi"]},
			{title: "fas fa-venus",searchTerms: ["venus"]},
			{title: "fas fa-venus-double",searchTerms: ["venus double","komdu tvöfalt"]},
			{title: "fas fa-venus-mars",searchTerms: ["venus mars","koma mars"]},
			{title: "fab fa-viacoin",searchTerms: ["viacoin"]},
			{title: "fab fa-viadeo",searchTerms: ["viadeo"]},
			{title: "fab fa-viadeo-square",searchTerms: ["viadeo square","viadeo torginu"]},
			{title: "fas fa-vial",searchTerms: ["vial","hettuglas"]},
			{title: "fas fa-vials",searchTerms: ["vials","hettuglös"]},
			{title: "fab fa-viber",searchTerms: ["viber"]},
			{title: "fas fa-video",searchTerms: ["video","myndband"]},
			{title: "fas fa-video-slash",searchTerms: ["video slash","vídeó rista"]},
			{title: "fab fa-vimeo",searchTerms: ["vimeo"]},
			{title: "fab fa-vimeo-square",searchTerms: ["vimeo square","vimeo torginu"]},
			{title: "fab fa-vimeo-v",searchTerms: ["vimeo v"]},
			{title: "fab fa-vine",searchTerms: ["vine","vínviður"]},
			{title: "fab fa-vk",searchTerms: ["vk"]},
			{title: "fab fa-vnv",searchTerms: ["vnv"]},
			{title: "fas fa-volleyball-ball",searchTerms: ["volleyball ball","blak boltinn"]},
			{title: "fas fa-volume-down",searchTerms: ["volume down","rúmmál niður"]},
			{title: "fas fa-volume-off",searchTerms: ["volume off","rúmmál af"]},
			{title: "fas fa-volume-up",searchTerms: ["volume up","hækka"]},
			{title: "fab fa-vuejs",searchTerms: ["vuejs"]},
			{title: "fas fa-walking",searchTerms: ["walking","ganga"]},
			{title: "fas fa-wallet",searchTerms: ["wallet","veski"]},
			{title: "fas fa-warehouse",searchTerms: ["warehouse","vörugeymsla"]},
			{title: "fab fa-weebly",searchTerms: ["weebly"]},
			{title: "fab fa-weibo",searchTerms: ["weibo","Weibo"]},
			{title: "fas fa-weight",searchTerms: ["weight","þyngd"]},
			{title: "fas fa-weight-hanging",searchTerms: ["weight hanging","þyngd hangandi"]},
			{title: "fab fa-weixin",searchTerms: ["weixin","Weixin"]},
			{title: "fab fa-whatsapp",searchTerms: ["whatsapp"]},
			{title: "fab fa-whatsapp-square",searchTerms: ["whatsapp square","whatsapp ferningur"]},
			{title: "fas fa-wheelchair",searchTerms: ["wheelchair","hjólastóll"]},
			{title: "fab fa-whmcs",searchTerms: ["whmcs"]},
			{title: "fas fa-wifi",searchTerms: ["wifi","Þráðlaust net"]},
			{title: "fab fa-wikipedia-w",searchTerms: ["wikipedia w"]},
			{title: "fas fa-window-close",searchTerms: ["window close","glugga loka"]},
			{title: "far fa-window-close",searchTerms: ["window close","glugga loka"]},
			{title: "fas fa-window-maximize",searchTerms: ["window maximize","glugga hámarka"]},
			{title: "far fa-window-maximize",searchTerms: ["window maximize","glugga hámarka"]},
			{title: "fas fa-window-minimize",searchTerms: ["window minimize","glugga lágmarka"]},
			{title: "far fa-window-minimize",searchTerms: ["window minimize","glugga lágmarka"]},
			{title: "fas fa-window-restore",searchTerms: ["window restore","gluggi endurheimt"]},
			{title: "far fa-window-restore",searchTerms: ["window restore","gluggi endurheimt"]},
			{title: "fab fa-windows",searchTerms: ["windows","gluggar"]},
			{title: "fas fa-wine-glass",searchTerms: ["wine glass","vínglas"]},
			{title: "fas fa-wine-glass-alt",searchTerms: ["wine glass alt","vín gler alt"]},
			{title: "fab fa-wix",searchTerms: ["wix"]},
			{title: "fab fa-wolf-pack-battalion",searchTerms: ["wolf pack battalion","úlfur pakki battalion"]},
			{title: "fas fa-won-sign",searchTerms: ["won sign","vann skilti"]},
			{title: "fab fa-wordpress",searchTerms: ["wordpress"]},
			{title: "fab fa-wordpress-simple",searchTerms: ["wordpress simple","wordpress einfalt"]},
			{title: "fab fa-wpbeginner",searchTerms: ["wpbeginner","wp byrjandi"]},
			{title: "fab fa-wpexplorer",searchTerms: ["wpexplorer"]},
			{title: "fab fa-wpforms",searchTerms: ["wpforms"]},
			{title: "fas fa-wrench",searchTerms: ["wrench","skiptilykill"]},
			{title: "fas fa-x-ray",searchTerms: ["x ray","x geisli"]},
			{title: "fab fa-xbox",searchTerms: ["xbox"]},
			{title: "fab fa-xing",searchTerms: ["xing","Xing"]},
			{title: "fab fa-xing-square",searchTerms: ["xing square","xing ferningur"]},
			{title: "fab fa-y-combinator",searchTerms: ["y combinator"]},
			{title: "fab fa-yahoo",searchTerms: ["yahoo"]},
			{title: "fab fa-yandex",searchTerms: ["yandex"]},
			{title: "fab fa-yandex-international",searchTerms: ["yandex international","yandex alþjóðlegt"]},
			{title: "fab fa-yelp",searchTerms: ["yelp"]},
			{title: "fas fa-yen-sign",searchTerms: ["yen sign","járnmerki"]},
			{title: "fab fa-yoast",searchTerms: ["yoast"]},
			{title: "fab fa-youtube",searchTerms: ["youtube","Youtube"]},
			{title: "fab fa-youtube-square",searchTerms: ["youtube square","æska torginu"]},
			{title: "fab fa-zhihu",searchTerms: ["zhihu","Zhihu"]}
		];
    }));
